// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aa-heading-two-xl {
  letter-spacing: -0.02em;
  font-size: 72px;
  font-weight: 400;
  line-height: 90px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-two-xl i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-two-xl.medium {
  font-weight: 500;
}
.aa-heading-two-xl.semibold {
  font-weight: 600;
}
.aa-heading-two-xl.bold {
  font-weight: 700;
}
.aa-heading-two-xl.center {
  text-align: center;
}

.aa-heading-xl {
  letter-spacing: -0.02em;
  font-size: 60px;
  font-weight: 400;
  line-height: 72px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-xl i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-xl.medium {
  font-weight: 500;
}
.aa-heading-xl.semibold {
  font-weight: 600;
}
.aa-heading-xl.bold {
  font-weight: 700;
}
.aa-heading-xl.center {
  text-align: center;
}

.aa-heading-lg {
  letter-spacing: -0.96px;
  font-size: 48px;
  font-weight: 400;
  line-height: 60px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-lg i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-lg.medium {
  font-weight: 500;
}
.aa-heading-lg.semibold {
  font-weight: 600;
}
.aa-heading-lg.bold {
  font-weight: 700;
}
.aa-heading-lg.center {
  text-align: center;
}

.aa-heading-md {
  font-size: 36px;
  font-weight: 400;
  line-height: 44px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-md i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-md.medium {
  font-weight: 500;
}
.aa-heading-md.semibold {
  font-weight: 600;
}
.aa-heading-md.bold {
  font-weight: 700;
}
.aa-heading-md.center {
  text-align: center;
}

.aa-heading-sm {
  font-size: 36px;
  font-weight: 400;
  line-height: 44px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-sm i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-sm.medium {
  font-weight: 500;
}
.aa-heading-sm.semibold {
  font-weight: 600;
}
.aa-heading-sm.bold {
  font-weight: 700;
}
.aa-heading-sm.center {
  text-align: center;
}

.aa-heading-xs {
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-heading-xs i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-heading-xs.medium {
  font-weight: 500;
}
.aa-heading-xs.semibold {
  font-weight: 600;
}
.aa-heading-xs.bold {
  font-weight: 700;
}
.aa-heading-xs.center {
  text-align: center;
}

.aa-text-xl {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-xl i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-xl.medium {
  font-weight: 500;
}
.aa-text-xl.semibold {
  font-weight: 600;
}
.aa-text-xl.bold {
  font-weight: 700;
}
.aa-text-xl.center {
  text-align: center;
}

.aa-text-lg {
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-lg i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-lg.medium {
  font-weight: 500;
}
.aa-text-lg.semibold {
  font-weight: 600;
}
.aa-text-lg.bold {
  font-weight: 700;
}
.aa-text-lg.center {
  text-align: center;
}

.aa-text-md {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-md i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-md.medium {
  font-weight: 500;
}
.aa-text-md.semibold {
  font-weight: 600;
}
.aa-text-md.bold {
  font-weight: 700;
}
.aa-text-md.center {
  text-align: center;
}

.aa-text-sm {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-sm i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-sm.medium {
  font-weight: 500;
}
.aa-text-sm.semibold {
  font-weight: 600;
}
.aa-text-sm.bold {
  font-weight: 700;
}
.aa-text-sm.center {
  text-align: center;
}

.aa-text-xs {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-xs i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-xs.medium {
  font-weight: 500;
}
.aa-text-xs.semibold {
  font-weight: 600;
}
.aa-text-xs.bold {
  font-weight: 700;
}
.aa-text-xs.center {
  text-align: center;
}

.aa-text-xxs {
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 1;
}
.aa-text-xxs i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-text-xxs.medium {
  font-weight: 500;
}
.aa-text-xxs.semibold {
  font-weight: 600;
}
.aa-text-xxs.bold {
  font-weight: 700;
}
.aa-text-xxs.center {
  text-align: center;
}

.aa-desc-xl {
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-xl i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-xl.medium {
  font-weight: 500;
}
.aa-desc-xl.semibold {
  font-weight: 600;
}
.aa-desc-xl.bold {
  font-weight: 700;
}
.aa-desc-xl.center {
  text-align: center;
}

.aa-desc-lg {
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-lg i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-lg.medium {
  font-weight: 500;
}
.aa-desc-lg.semibold {
  font-weight: 600;
}
.aa-desc-lg.bold {
  font-weight: 700;
}
.aa-desc-lg.center {
  text-align: center;
}

.aa-desc-md {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-md i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-md.medium {
  font-weight: 500;
}
.aa-desc-md.semibold {
  font-weight: 600;
}
.aa-desc-md.bold {
  font-weight: 700;
}
.aa-desc-md.center {
  text-align: center;
}

.aa-desc-sm {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-sm i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-sm.medium {
  font-weight: 500;
}
.aa-desc-sm.semibold {
  font-weight: 600;
}
.aa-desc-sm.bold {
  font-weight: 700;
}
.aa-desc-sm.center {
  text-align: center;
}

.aa-desc-xs {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-xs i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-xs.medium {
  font-weight: 500;
}
.aa-desc-xs.semibold {
  font-weight: 600;
}
.aa-desc-xs.bold {
  font-weight: 700;
}
.aa-desc-xs.center {
  text-align: center;
}

.aa-desc-xxs {
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  color: var(--AA-gloabl-text-color);
  text-align: start;
  margin: 0;
  opacity: 0.5;
}
.aa-desc-xxs i {
  flex-shrink: 0;
  cursor: pointer;
  color: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.aa-desc-xxs.medium {
  font-weight: 500;
}
.aa-desc-xxs.semibold {
  font-weight: 600;
}
.aa-desc-xxs.bold {
  font-weight: 700;
}
.aa-desc-xxs.center {
  text-align: center;
}

*::before,
*::after {
  box-sizing: border-box;
}

* {
  font-family: var(--AA-font-family);
  box-sizing: border-box;
}

button {
  cursor: pointer;
}

applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
caption,
tbody,
tfoot,
thead,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  text-align: start;
}

html {
  overflow: hidden;
  height: 100%;
}

body {
  height: 100%;
  line-height: normal;
  padding: 20px;
}

.agentassist-widget-main-chat-container-wrapper {
  color: var(--AA-gloabl-text-color);
}

:focus-visible {
  outline-color: var(--AA-global-theme-bg);
  outline-offset: 1px;
  outline-style: auto;
}

body::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  cursor: pointer;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  cursor: pointer;
}

::-webkit-scrollbar-thumb {
  background-color: var(--AA-gloabl-bg-secondary);
  border-radius: 7px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
}
::-webkit-scrollbar-thumb:hover {
  background-color: var(--AA-gloabl-border);
}

body {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
}

.agentassist-widget-main-chat-container-wrapper {
  color: var(--AA-gloabl-text-color);
  background-color: var(--AA-global-white-bg);
}

h6, h5, h4, h3, h2, h1 {
  margin-top: 0;
  margin-bottom: 0px;
  font-weight: 400;
  line-height: normal;
}

.paragraph {
  margin: 0;
  font-weight: 400;
  line-height: 20px;
  color: var(--AA-gloabl-text-color);
}

.paragraph.semibold {
  font-weight: 600;
}

.h-100 {
  height: 100%;
}

.w-100 {
  width: 100%;
}

p {
  margin: 0;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

.disabled-msg {
  opacity: 0.5;
  pointer-events: none;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

b,
strong {
  font-weight: 700;
}

sub,
sup {
  position: relative;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--AA-global-theme-text-color);
  text-decoration: none;
  cursor: pointer;
}
a:hover {
  color: var(--AA-global-theme-text-color);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

figure {
  margin: 0;
  line-height: 0;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

th {
  font-weight: 500;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
  cursor: pointer;
}
button:disabled,
[type=button]:disabled,
[type=reset]:disabled,
[type=submit]:disabled {
  opacity: 0.3;
  pointer-events: none;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

iframe {
  border: 0;
}

[hidden] {
  display: none !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.aa-d-none {
  display: none !important;
}

.aa-hidden {
  display: none !important;
}

.more-link-text {
  cursor: pointer;
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--AA-global-theme-text-color);
}

.aa-solidbtn {
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  padding: 5px 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
}

.aa-btn-link {
  color: var(--AA-global-theme-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
}

.aa_btn {
  padding: 4px 14px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--AA-gloabl-text-color);
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  transition: 0.2s all ease;
}
.aa_btn.w-100 {
  width: 100%;
}
.aa_btn:disabled {
  opacity: 0.3;
}

.aa-danger-btn {
  background: #D92D20;
  border-color: #D92D20;
  color: #fff;
}
.aa-danger-btn:hover {
  background: #b42318;
  border: 1px solid #b42318;
}

.primaryBtn {
  border: 1px solid var(--AA-global-theme-text-color);
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
}
.primaryBtn:focus {
  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.primaryBtn:active {
  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.primaryBtn:hover {
  border: 1px solid var(--AA-global-theme-bg);
  background: var(--AA-global-theme-bg);
}

.aa-p-0 {
  padding: 0 !important;
}

.h_100 {
  height: 100%;
}

@keyframes bottomToTopMove {
  0% {
    opacity: 0;
    transform: translateY(100%);
    display: none;
  }
  60% {
    display: none;
    opacity: 0;
  }
  100% {
    opacity: 1;
    display: block;
    transform: translateY(0%);
  }
}
.animate-compo-slide-up-wrapper {
  height: 100%;
  animation-name: bottomToTopMove;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

:root {
  --AA-font-family: "Inter";
  --AA-primary-color:#2970FF;
  --AA-secondary-color:#f8fafc;
  --AA-primary-text:#101828;
  --AA-secondary-text:#FFFFFF;
  --AA-body-background:#FFFFFF;
  --AA-warning-color:#D92D20;
  --AA-global-theme-bg:var(--AA-primary-color);
  --AA-global-theme-text-color:var(--AA-primary-color);
  --AA-gloabl-bg-secondary:var(--AA-secondary-color);
  --AA-global-white-color:var(--AA-secondary-text);
  --AA-global-white-bg:var(--AA-body-background);
  --AA-gloabl-text-color:var(--AA-primary-text);
  --AA-gloabl-text-desc-color:var(--AA-primary-text);
  --AA-gloabl-border:var(--AA-secondary-color);
  --AA-gloabl-scrollbar-bg:var(--AA-secondary-color);
  --AA-static-border:var(--AA-gloabl-border);
  --sdk-global-theme-color:var(--AA-primary-color) !important;
  --sdk-gloabl-bg-secondary:var(--AA-secondary-color) !important;
  --sdk-global_white:var(--AA-body-background) !important;
  --sdk-global-white-bg:var(--AA-body-background) !important;
  --sdk-gloabl-text-color:var(--AA-primary-text) !important;
  --sdk-gloabl-text-desc-color:var(--AA-secondary-text) !important;
  --sdk-gloabl-border-color:var(--AA-secondary-color) !important;
  --sdk-scrollbar-bg:var(--AA-secondary-color);
}

.aa-toggle-switch {
  position: relative;
  display: block;
}
.aa-toggle-switch input {
  opacity: 0;
  position: absolute;
  z-index: 9;
  cursor: pointer;
  width: 28px;
  height: 16px;
  left: 0;
  top: 0px;
  line-height: normal;
  font-size: 0;
}
.aa-toggle-switch input:checked + .aa-slider .slide-parent .slider-btn {
  background-color: var(--AA-global-theme-bg);
}
.aa-toggle-switch input:checked + .aa-slider .slide-parent .slider-btn::before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}
.aa-toggle-switch input:checked + .aa-slider span {
  font-size: 12px;
  color: var(--AA-gloabl-text-color);
  cursor: pointer;
  font-weight: 500;
}
.aa-toggle-switch input:checked + .aa-slider span.enabled {
  display: block;
}
.aa-toggle-switch input:checked + .aa-slider span.disabled {
  display: none;
}
.aa-toggle-switch input:checked:disabled + .aa-slider .slide-parent .slider-btn {
  opacity: 0.5;
}
.aa-toggle-switch input:disabled {
  cursor: auto;
}
.aa-toggle-switch input:disabled + .aa-slider .slide-parent .slider-btn {
  opacity: 0.5;
}
.aa-toggle-switch .aa-slider {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  background: transparent;
  padding: 0;
  border: 0;
  outline: 0;
}
.aa-toggle-switch .aa-slider .slide-parent {
  position: relative;
  width: 28px;
  height: 16px;
}
.aa-toggle-switch .aa-slider .slide-parent .slider-btn {
  position: absolute;
  cursor: pointer;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
  border-radius: 10px;
  background: var(--AA-global-white-bg);
  border: 0;
  padding: 0;
  outline: 0;
}
.aa-toggle-switch .aa-slider .slide-parent .slider-btn:focus {
  box-shadow: 0px 0px 0px 4px #EFF4FF;
}
.aa-toggle-switch .aa-slider .slide-parent .slider-btn::before {
  position: absolute;
  content: "";
  height: 12px;
  width: 12px;
  top: 2px;
  left: 2px;
  right: 0;
  background-color: var(--AA-global-white-bg);
  transition: 0.4s;
  border-radius: 50%;
  filter: drop-shadow(0px 0.778px 1.556px rgba(16, 24, 40, 0.06)) drop-shadow(0px 0.778px 2.333px rgba(16, 24, 40, 0.1));
}
.aa-toggle-switch .aa-slider span {
  font-size: 12px;
  color: var(--AA-gloabl-text-color);
  cursor: pointer;
  font-weight: 500;
}
.aa-toggle-switch .aa-slider span.no {
  color: var(--AA-gloabl-text-color);
}
.aa-toggle-switch .aa-slider span.enabled {
  color: var(--AA-gloabl-text-color);
  display: none;
}
.aa-toggle-switch .aa-slider span.disabled {
  display: block;
}

.aa-dropdown {
  position: relative;
}
.aa-dropdown .aa-dropdown-toggle {
  white-space: nowrap;
}
.aa-dropdown.show .aa-dropdown-toggle svg.arrow-icon {
  transform: rotate(180deg);
}
.aa-dropdown.show .aa-dropdown-content {
  display: block;
}
.aa-dropdown.aa-elipse-dropdown .aa-dropdown-toggle {
  display: flex;
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: var(--AA-gloabl-bg-secondary);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
  border: 0;
  padding: 0;
}
.aa-dropdown.aa-elipse-dropdown .aa-dropdown-content {
  right: 0;
  padding: 0;
}

.aa-dropdown-content {
  position: absolute;
  z-index: 1000;
  display: none;
  min-width: auto;
  margin: 0;
  color: var(--AA-gloabl-text-color);
  text-align: left;
  list-style: none;
  background-clip: padding-box;
  border-radius: 8px;
  background: var(--AA-global-white-bg);
  box-shadow: 0px 4px 8px 0px rgba(32, 33, 36, 0.15);
  border: 0;
  padding: 8px 12px;
}

.aa-dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  clear: both;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  border-radius: 6px;
}
.aa-dropdown-item:hover, .aa-dropdown-item:focus {
  color: var(--AA-gloabl-text-color);
  background: var(--AA-gloabl-bg-secondary);
}
.aa-dropdown-item.active, .aa-dropdown-item:active {
  color: var(--AA-gloabl-text-color);
  text-decoration: none;
  background: var(--AA-gloabl-bg-secondary);
}
.aa-dropdown-item.disabled, .aa-dropdown-item:disabled {
  opacity: 0.5;
  pointer-events: none;
  background-color: transparent;
}

.playbook-dropdown-content {
  min-width: 250px;
  max-height: 300px;
  overflow: auto;
  max-width: 350px;
}
.playbook-dropdown-content .heading-text-scripts {
  border-radius: 8px 8px 0px 0px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 8px 10px;
  color: var(--AA-gloabl-text-color);
  font-size: 11px;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
}
.playbook-dropdown-content .aa-dropdown-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 1px 0;
  white-space: normal;
}
.playbook-dropdown-content .aa-dropdown-item.selected {
  background: var(--AA-gloabl-bg-secondary);
}
.playbook-dropdown-content .aa-dropdown-item p {
  width: 100%;
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.playbook-dropdown-content .aa-dropdown-item .primaryBtn {
  border-radius: 16px;
  background: var(--AA-global-theme-bg);
  color: var(--AA-global-white-color);
  font-size: 12px;
  font-weight: 500;
  height: 22px;
  padding: 0 8px;
  flex-shrink: 0;
}
.playbook-dropdown-content .aa-dropdown-item span {
  flex-shrink: 0;
  color: var(--AA-gloabl-text-desc-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  opacity: 0.8;
}

.a-gap-4 {
  gap: 4px;
}

.a-gap-6 {
  gap: 6px;
}

.a-gap-8 {
  gap: 8px;
}

.a-gap-10 {
  gap: 10px;
}

.a-gap-12 {
  gap: 12px;
}

.a-gap-16 {
  gap: 16px;
}

.a-gap-20 {
  gap: 20px;
}

.a-gap-24 {
  gap: 24px;
}

.a-gap-sm {
  gap: 8px;
}

.a-gap-md {
  gap: 16px;
}

.a-gap-lg {
  gap: 24px;
}

.a-gap-xl {
  gap: 32px;
}

.a-gap-xxl {
  gap: 48px;
}

.a-radius-4 {
  border-radius: 4px;
}

.a-radius-6 {
  border-radius: 6px;
}

.a-radius-8 {
  border-radius: 8px;
}

.a-radius-12 {
  border-radius: 12px;
}

.a-radius-16 {
  border-radius: 16px;
}

.a-radius-999 {
  border-radius: 999px;
}

.a-padding-default {
  padding: 24px;
}

.a-padding-default-top {
  padding-top: 24px;
}

.a-padding-default-bottom {
  padding-bottom: 24px;
}

.a-padding-default-left {
  padding-left: 24px;
}

.a-padding-default-right {
  padding-right: 24px;
}

.a-padding-xs {
  padding: 4px;
}

.a-padding-xs-top {
  padding-top: 4px;
}

.a-padding-xs-bottom {
  padding-bottom: 4px;
}

.a-padding-xs-left {
  padding-left: 4px;
}

.a-padding-xs-right {
  padding-right: 4px;
}

.a-padding-sm {
  padding: 8px;
}

.a-padding-sm-top {
  padding-top: 8px;
}

.a-padding-sm-bottom {
  padding-bottom: 8px;
}

.a-padding-sm-left {
  padding-left: 8px;
}

.a-padding-sm-right {
  padding-right: 8px;
}

.a-padding-smm {
  padding: 10px;
}

.a-padding-smm-top {
  padding-top: 10px;
}

.a-padding-smm-bottom {
  padding-bottom: 10px;
}

.a-padding-smm-left {
  padding-left: 10px;
}

.a-padding-smm-right {
  padding-right: 10px;
}

.a-padding-md {
  padding: 12px;
}

.a-padding-md-top {
  padding-top: 12px;
}

.a-padding-md-bottom {
  padding-bottom: 12px;
}

.a-padding-md-left {
  padding-left: 12px;
}

.a-padding-md-right {
  padding-right: 12px;
}

.a-padding-lg {
  padding: 16px;
}

.a-padding-lg-top {
  padding-top: 16px;
}

.a-padding-lg-bottom {
  padding-bottom: 16px;
}

.a-padding-lg-left {
  padding-left: 16px;
}

.a-padding-lg-right {
  padding-right: 16px;
}

.a-padding-xl {
  padding: 20px;
}

.a-padding-xl-top {
  padding-top: 20px;
}

.a-padding-xl-bottom {
  padding-bottom: 20px;
}

.a-padding-xl-left {
  padding-left: 20px;
}

.a-padding-xl-right {
  padding-right: 20px;
}

.a-padding-xxl {
  padding: 24px;
}

.a-padding-xxl-top {
  padding-top: 24px;
}

.a-padding-xxl-bottom {
  padding-bottom: 24px;
}

.a-padding-xxl-left {
  padding-left: 24px;
}

.a-padding-xxl-right {
  padding-right: 24px;
}

.a-p-0 {
  padding: 0 !important;
}

.a-m-0 {
  margin: 0 !important;
}

.a-mb-8 {
  margin-bottom: var(--default, 8px);
}

.a-gap-4 {
  gap: var(--default, 4px);
}

.a-gap-8 {
  gap: var(--default, 8px);
}

.a-gap-12 {
  gap: var(--default, 12px);
}

.a-gap-16 {
  gap: var(--default, 16px);
}

.a-position-relative {
  position: relative;
}

.a-position-absolute {
  position: absolute;
}

.a-d-none {
  display: none;
}

.a-flex {
  display: flex;
}

.a-flex-shrink-0 {
  flex-shrink: 0;
}

.a-flex-inline {
  display: inline-flex;
}

.a-flex-row {
  flex-direction: row;
}

.a-flex-row-reverse {
  flex-direction: row-reverse;
}

.a-flex-column {
  flex-direction: column;
}

.a-flex-column-reverse {
  flex-direction: column-reverse;
}

.a-flex-wrap {
  flex-wrap: wrap;
}

.a-flex-nowrap {
  flex-wrap: nowrap;
}

.a-flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}

.a-justify-content-start {
  justify-content: flex-start;
}

.a-justify-content-end {
  justify-content: flex-end;
}

.a-justify-content-center {
  justify-content: center;
}

.a-justify-content-between {
  justify-content: space-between;
}

.a-justify-content-around {
  justify-content: space-around;
}

.a-align-items-start {
  align-items: flex-start;
}

.a-align-items-end {
  align-items: flex-end;
}

.a-align-items-center {
  align-items: center;
}

.a-align-items-baseline {
  align-items: baseline;
}

.a-align-items-stretch {
  align-items: stretch;
}

.a-align-content-start {
  align-content: flex-start;
}

.a-align-content-end {
  align-content: flex-end;
}

.a-align-content-center {
  align-content: center;
}

.a-align-content-between {
  align-content: space-between;
}

.a-align-content-around {
  align-content: space-around;
}

.a-width-100 {
  width: 100%;
}

.a-height-100 {
  height: 100%;
}

.a-overflow-hidden {
  overflow: hidden;
}

.a-form-checkbox-switch {
  position: relative;
}
.a-form-checkbox-switch input {
  width: 28px;
  height: 16px;
  appearance: none;
  border: 1px solid var(--AA-static-border, #E4E7EC);
  border-radius: 16px;
  transition: background-position 0.15s ease-in-out;
}
.a-form-checkbox-switch input + .a-form-checkbox-switch-round {
  width: 10px;
  height: 10px;
  border-radius: 16px;
  background-color: var(--AA-static-border, #E4E7EC);
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.15s ease-in-out;
}
.a-form-checkbox-switch input:checked {
  background-color: var(--AA-global-theme-bg);
}
.a-form-checkbox-switch input:checked + .a-form-checkbox-switch-round {
  background-color: var(--AA-global-white-bg);
  transform: translateX(12px);
}

.badge-text {
  height: 16px;
  padding: 2px 8px;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  color: var(--AA-gloabl-text-color);
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
}

.radio-check-form input {
  width: 16px;
  height: 16px;
  outline: 1px solid var(--AA-static-border);
  appearance: none;
  border-radius: 100%;
  flex-shrink: 0;
  cursor: pointer;
}
.radio-check-form input:checked {
  background: var(--AA-global-theme-bg);
  border: 4px solid var(--AA-global-white-bg);
  outline-color: var(--AA-global-theme-bg);
}
.radio-check-form label {
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.a-text-uppercase {
  text-transform: uppercase;
}

.aa-tooltip {
  position: fixed;
  max-width: 300px;
  border: 0px solid var(--AA-gloabl-border);
  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  background: var(--AA-global-white-bg);
  border-radius: 8px;
  padding: 9px 12px;
  color: var(--AA-gloabl-text-color);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  min-width: 150px;
  z-index: 9999;
}
.aa-tooltip.aa-custom-tooltip {
  background: var(--AA-primary-color);
  color: var(--AA-global-white-color);
}
.aa-tooltip.tooltip-top {
  margin-top: -5px;
  transform: translate(-50%, -50%) !important;
}
.aa-tooltip.tooltip-bottom {
  margin-top: 5px;
}
.aa-tooltip.tooltip-left {
  margin-left: -5px;
  transform: translate(-100%, -50%) !important;
}
.aa-tooltip.tooltip-right {
  margin-left: 5px;
  transform: translate(0, -50%) !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/_typography.scss","webpack://./src/components/aaWindow/_aaWindow.scss","webpack://./src/scss/_AaReboot.scss","webpack://./src/scss/_variable.scss","webpack://./src/scss/_toggle.scss","webpack://./src/scss/_aaDropdowns.scss","webpack://./src/scss/utilities.scss","webpack://./src/scss/_tooltip.scss"],"names":[],"mappings":"AA+BA;EACI,uBAAA;EA/BA,eAgC4B;EA/B5B,gBA+BkC;EA9BlC,iBA8BuC;EA7BvC,kCA6B6C;EA5B7C,iBA4B0E;EA3B1E,SAAA;EACA,UA0BiF;ACxBrF;ADEI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACAR;ADEI;EACI,gBAAA;ACAR;ADEI;EACI,gBAAA;ACAR;ADEI;EACI,gBAAA;ACAR;ADEI;EACI,kBAAA;ACAR;;ADSA;EACI,uBAAA;EApCA,eAqC4B;EApC5B,gBAoCkC;EAnClC,iBAmCuC;EAlCvC,kCAkC6C;EAjC7C,iBAiC0E;EAhC1E,SAAA;EACA,UA+BiF;ACArF;AD3BI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC6BR;AD3BI;EACI,gBAAA;AC6BR;AD3BI;EACI,gBAAA;AC6BR;AD3BI;EACI,gBAAA;AC6BR;AD3BI;EACI,kBAAA;AC6BR;;ADfA;EACI,uBAAA;EAzCA,eA0C4B;EAzC5B,gBAyCkC;EAxClC,iBAwCuC;EAvCvC,kCAuC6C;EAtC7C,iBAsC0E;EArC1E,SAAA;EACA,UAoCiF;ACwBrF;ADxDI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC0DR;ADxDI;EACI,gBAAA;AC0DR;ADxDI;EACI,gBAAA;AC0DR;ADxDI;EACI,gBAAA;AC0DR;ADxDI;EACI,kBAAA;AC0DR;;ADvCA;EA7CI,eA8C4B;EA7C5B,gBA6CkC;EA5ClC,iBA4CuC;EA3CvC,kCA2C6C;EA1C7C,iBA0C0E;EAzC1E,SAAA;EACA,UAwCiF;ACgDrF;ADpFI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACsFR;ADpFI;EACI,gBAAA;ACsFR;ADpFI;EACI,gBAAA;ACsFR;ADpFI;EACI,gBAAA;ACsFR;ADpFI;EACI,kBAAA;ACsFR;;AD/DA;EAjDI,eAkD4B;EAjD5B,gBAiDkC;EAhDlC,iBAgDuC;EA/CvC,kCA+C6C;EA9C7C,iBA8C0E;EA7C1E,SAAA;EACA,UA4CiF;ACwErF;ADhHI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACkHR;ADhHI;EACI,gBAAA;ACkHR;ADhHI;EACI,gBAAA;ACkHR;ADhHI;EACI,gBAAA;ACkHR;ADhHI;EACI,kBAAA;ACkHR;;ADvFA;EArDI,eAsD4B;EArD5B,gBAqDkC;EApDlC,iBAoDuC;EAnDvC,kCAmD6C;EAlD7C,iBAkD0E;EAjD1E,SAAA;EACA,UAgDiF;ACgGrF;AD5II;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC8IR;AD5II;EACI,gBAAA;AC8IR;AD5II;EACI,gBAAA;AC8IR;AD5II;EACI,gBAAA;AC8IR;AD5II;EACI,kBAAA;AC8IR;;AD7GA;EA3DI,eA4D4B;EA3D5B,gBA2DkC;EA1DlC,iBA0DuC;EAzDvC,kCAyD6C;EAxD7C,iBAwD0E;EAvD1E,SAAA;EACA,UAsDiF;ACsHrF;ADxKI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC0KR;ADxKI;EACI,gBAAA;AC0KR;ADxKI;EACI,gBAAA;AC0KR;ADxKI;EACI,gBAAA;AC0KR;ADxKI;EACI,kBAAA;AC0KR;;ADrIA;EA/DI,eAgE4B;EA/D5B,gBA+DkC;EA9DlC,iBA8DuC;EA7DvC,kCA6D6C;EA5D7C,iBA4D0E;EA3D1E,SAAA;EACA,UA0DiF;AC8IrF;ADpMI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACsMR;ADpMI;EACI,gBAAA;ACsMR;ADpMI;EACI,gBAAA;ACsMR;ADpMI;EACI,gBAAA;ACsMR;ADpMI;EACI,kBAAA;ACsMR;;AD7JA;EAnEI,eAoE4B;EAnE5B,gBAmEkC;EAlElC,iBAkEuC;EAjEvC,kCAiE6C;EAhE7C,iBAgE0E;EA/D1E,SAAA;EACA,UA8DiF;ACsKrF;ADhOI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACkOR;ADhOI;EACI,gBAAA;ACkOR;ADhOI;EACI,gBAAA;ACkOR;ADhOI;EACI,gBAAA;ACkOR;ADhOI;EACI,kBAAA;ACkOR;;ADrLA;EAvEI,eAwE4B;EAvE5B,gBAuEkC;EAtElC,iBAsEuC;EArEvC,kCAqE6C;EApE7C,iBAoE0E;EAnE1E,SAAA;EACA,UAkEiF;AC8LrF;AD5PI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC8PR;AD5PI;EACI,gBAAA;AC8PR;AD5PI;EACI,gBAAA;AC8PR;AD5PI;EACI,gBAAA;AC8PR;AD5PI;EACI,kBAAA;AC8PR;;AD7MA;EA3EI,eA4E4B;EA3E5B,gBA2EkC;EA1ElC,iBA0EuC;EAzEvC,kCAyE6C;EAxE7C,iBAwE0E;EAvE1E,SAAA;EACA,UAsEiF;ACsNrF;ADxRI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC0RR;ADxRI;EACI,gBAAA;AC0RR;ADxRI;EACI,gBAAA;AC0RR;ADxRI;EACI,gBAAA;AC0RR;ADxRI;EACI,kBAAA;AC0RR;;ADtOA;EA9EI,eA+E4B;EA9E5B,gBA8EkC;EA7ElC,iBA6EuC;EA5EvC,kCA4E6C;EA3E7C,iBA2E0E;EA1E1E,SAAA;EACA,UAyEiF;AC+OrF;ADpTI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACsTR;ADpTI;EACI,gBAAA;ACsTR;ADpTI;EACI,gBAAA;ACsTR;ADpTI;EACI,gBAAA;ACsTR;ADpTI;EACI,kBAAA;ACsTR;;AD3PA;EArFI,eAsF4B;EArF5B,gBAqFkC;EApFlC,iBAoFuC;EAnFvC,kCAmF6C;EAlF7C,iBAkF0E;EAjF1E,SAAA;EACA,YAgFiF;ACoQrF;ADhVI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACkVR;ADhVI;EACI,gBAAA;ACkVR;ADhVI;EACI,gBAAA;ACkVR;ADhVI;EACI,gBAAA;ACkVR;ADhVI;EACI,kBAAA;ACkVR;;ADnRA;EAzFI,eA0F4B;EAzF5B,gBAyFkC;EAxFlC,iBAwFuC;EAvFvC,kCAuF6C;EAtF7C,iBAsF0E;EArF1E,SAAA;EACA,YAoFiF;AC4RrF;AD5WI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC8WR;AD5WI;EACI,gBAAA;AC8WR;AD5WI;EACI,gBAAA;AC8WR;AD5WI;EACI,gBAAA;AC8WR;AD5WI;EACI,kBAAA;AC8WR;;AD3SA;EA7FI,eA8F4B;EA7F5B,gBA6FkC;EA5FlC,iBA4FuC;EA3FvC,kCA2F6C;EA1F7C,iBA0F0E;EAzF1E,SAAA;EACA,YAwFiF;ACoTrF;ADxYI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC0YR;ADxYI;EACI,gBAAA;AC0YR;ADxYI;EACI,gBAAA;AC0YR;ADxYI;EACI,gBAAA;AC0YR;ADxYI;EACI,kBAAA;AC0YR;;ADnUA;EAjGI,eAkG4B;EAjG5B,gBAiGkC;EAhGlC,iBAgGuC;EA/FvC,kCA+F6C;EA9F7C,iBA8F0E;EA7F1E,SAAA;EACA,YA4FiF;AC4UrF;ADpaI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACsaR;ADpaI;EACI,gBAAA;ACsaR;ADpaI;EACI,gBAAA;ACsaR;ADpaI;EACI,gBAAA;ACsaR;ADpaI;EACI,kBAAA;ACsaR;;AD3VA;EArGI,eAsG4B;EArG5B,gBAqGkC;EApGlC,iBAoGuC;EAnGvC,kCAmG6C;EAlG7C,iBAkG0E;EAjG1E,SAAA;EACA,YAgGiF;ACoWrF;ADhcI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;ACkcR;ADhcI;EACI,gBAAA;ACkcR;ADhcI;EACI,gBAAA;ACkcR;ADhcI;EACI,gBAAA;ACkcR;ADhcI;EACI,kBAAA;ACkcR;;ADnXA;EAzGI,eA0G4B;EAzG5B,gBAyGkC;EAxGlC,iBAwGuC;EAvGvC,kCAuG6C;EAtG7C,iBAsG0E;EArG1E,SAAA;EACA,YAoGiF;AC4XrF;AD5dI;EACI,cAAA;EACA,eAAA;EACA,kCAAA;EACA,YAAA;AC8dR;AD5dI;EACI,gBAAA;AC8dR;AD5dI;EACI,gBAAA;AC8dR;AD5dI;EACI,gBAAA;AC8dR;AD5dI;EACI,kBAAA;AC8dR;;ACtfA;;EAEI,sBAAA;ADyfJ;;ACtfA;EACI,kCAAA;EACA,sBAAA;ADyfJ;;ACtfA;EACI,eAAA;ADyfJ;;ACtfA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAuEI,SAAA;EACA,UAAA;EACA,SAAA;EAEA,wBAAA;ADwfJ;;ACrfA;;;;;;EAMI,iBAAA;ADwfJ;;ACrfA;EACI,gBAAA;EACA,YAAA;ADwfJ;;ACrfA;EACI,YAAA;EACA,mBAAA;EACA,aAAA;ADwfJ;;ACrfA;EACI,kCAAA;ADwfJ;;ACrfA;EACI,wCAAA;EACA,mBAAA;EACA,mBAAA;ADwfJ;;ACrfA;EACI,WAAA;EACA,YAAA;EACA,eAAA;ADwfJ;;ACrfA;EACI,UAAA;EACA,WAAA;EACA,eAAA;ADwfJ;;ACrfA;EACI,+CAAA;EACA,kBAAA;EACA,gEAAA;EACA,wEAAA;ADwfJ;ACtfI;EACI,yCAAA;ADwfR;;ACpfA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,8BAAA;ADufJ;;ACpfA;EACI,kCAAA;EACA,2CAAA;ADufJ;;AClfA;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ADqfJ;;AC1dA;EACI,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;AD6dJ;;ACvdI;EACI,gBAAA;AD0dR;;ACtdA;EACI,YAAA;ADydJ;;ACtdA;EACI,WAAA;ADydJ;;ACtdA;EACI,SAAA;ADydJ;;ACpdA;;EAEI,kBAAA;ADudJ;;ACpdA;;;EAGI,aAAA;EACA,mBAAA;ADudJ;;ACpdA;EACI,YAAA;EACA,oBAAA;ADudJ;;ACpdA;;;;EAII,gBAAA;ADudJ;;ACldA;EACI,qBAAA;EACA,cAAA;ADqdJ;;ACldA;;EAEI,gBAAA;ADqdJ;;ACldA;;EAEI,kBAAA;EACA,cAAA;EACA,wBAAA;ADqdJ;;ACldA;EACI,eAAA;ADqdJ;;ACldA;EACI,WAAA;ADqdJ;;AChdA;EACI,wCAAA;EACA,qBAAA;EACA,eAAA;ADmdJ;ACjdI;EACI,wCAAA;ADmdR;;AC7cI;EAEI,cAAA;EACA,qBAAA;AD+cR;;AC3cA;EACI,SAAA;EACA,cAAA;AD8cJ;;ACxcA;;EAEI,sBAAA;AD2cJ;;ACxcA;EACI,oBAAA;EACA,yBAAA;AD2cJ;;ACxcA;EACI,gBAAA;EACA,mBAAA;EACA,gCAAA;AD2cJ;;ACxcA;;;;;;EAMI,qBAAA;EACA,mBAAA;EACA,eAAA;AD2cJ;;ACvcA;EACI,qBAAA;AD0cJ;;ACvcA;EACI,UAAA;AD0cJ;;ACvcA;;;;;EAKI,SAAA;EACA,oBAAA;EACA,oBAAA;AD0cJ;;ACvcA;;EAEI,oBAAA;AD0cJ;;ACvcA;EACI,eAAA;AD0cJ;;ACvcA;EACI,wBAAA;AD0cJ;;ACvcA;;;;EAKI,0BAAA;EACA,eAAA;ADycJ;ACvcI;;;;EACI,YAAA;EACA,oBAAA;AD4cR;;ACxcA;EACI,UAAA;EACA,kBAAA;AD2cJ;;ACxcA;EACI,gBAAA;AD2cJ;;ACxcA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;AD2cJ;;ACxcA;;;;;;;EAOI,UAAA;AD2cJ;;ACxcA;EACI,YAAA;AD2cJ;;ACxcA;EACI,6BAAA;EACA,oBAAA;AD2cJ;;ACtcA;EACI,wBAAA;ADycJ;;ACpcA;EACI,UAAA;ADucJ;;ACpcA;EACI,aAAA;EACA,0BAAA;ADucJ;;ACpcA;EACI,SAAA;ADucJ;;ACpcA;EACI,wBAAA;ADucJ;;ACpcA;;EAEI,wBAAA;EACA,SAAA;ADucJ;;ACpcA,YAAA;AACA;EACI,0BAAA;ADucJ;;ACpcA;EACI,wBAAA;ADucJ;;ACrcA;EACI,wBAAA;ADwcJ;;ACrcA;EACI,eAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,wCAAA;ADwcJ;;ACrcA;EACI,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ADwcJ;;ACpcA;EACI,wCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;ADucJ;;ACpcA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,kDAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;ADucJ;ACtcI;EACE,WAAA;ADwcN;ACtcI;EACE,YAAA;ADwcN;;ACpcA;EACI,mBAAA;EACA,qBAAA;EACA,WAAA;ADucJ;ACtcI;EACI,mBAAA;EACA,yBAAA;ADwcR;;ACncA;EACI,mDAAA;EACA,qCAAA;EACA,mCAAA;ADscJ;ACrcI;EACE,2EAAA;ADucN;ACrcI;EACE,2EAAA;ADucN;ACrcI;EACE,2CAAA;EACA,qCAAA;ADucN;;ACncA;EACI,qBAAA;ADscJ;;AClcA;EACI,YAAA;ADqcJ;;ACncA;EACI;IACE,UAAA;IACA,2BAAA;IACA,aAAA;EDscJ;ECpcE;IACI,aAAA;IACA,UAAA;EDscN;ECpcE;IACE,UAAA;IACA,cAAA;IACA,yBAAA;EDscJ;AACF;ACncA;EACI,YAAA;EACA,+BAAA;EACA,wBAAA;EACA,6BAAA;ADqcJ;;AEt/BA;EACE,yBAAA;EAGA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EAEA,4BAAA;EACA,0BAAA;EAGA,4CAAA;EACA,oDAAA;EACA,kDAAA;EACA,gDAAA;EACA,8CAAA;EACA,6CAAA;EACA,kDAAA;EACA,4CAAA;EACA,kDAAA;EAIA,0CAAA;EAKA,2DAAA;EACA,8DAAA;EACA,uDAAA;EACA,0DAAA;EACA,yDAAA;EACA,gEAAA;EACA,8DAAA;EACA,4CAAA;AF6+BF;;AGrhCA;EACI,kBAAA;EACA,cAAA;AHwhCJ;AGvhCI;EACI,UAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AHyhCR;AGrhCoB;EACI,2CAAA;AHuhCxB;AGthCwB;EACI,mCAAA;EACA,+BAAA;EACA,2BAAA;AHwhC5B;AGphCgB;EACI,eAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;AHshCpB;AG/gCoB;EACI,cAAA;AHihCxB;AG/gCoB;EACI,aAAA;AHihCxB;AG1gCwB;EACI,YAAA;AH4gC5B;AGtgCQ;EACI,YAAA;AHwgCZ;AGrgCoB;EACI,YAAA;AHugCxB;AGjgCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AHmgCR;AGlgCQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AHogCZ;AGngCY;EACI,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AHqgChB;AGpgCgB;EACI,mCAAA;AHsgCpB;AGpgCgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;EACA,gBAAA;EACA,kBAAA;EACA,sHAAA;AHsgCpB;AGlgCQ;EACI,eAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;AHogCZ;AGhgCY;EACI,kCAAA;AHkgChB;AG7/BY;EACI,kCAAA;EACA,aAAA;AH+/BhB;AG7/BY;EACI,cAAA;AH+/BhB;;AIjoCA;EACI,kBAAA;AJooCJ;AInoCI;EACI,mBAAA;AJqoCR;AIhoCgB;EACI,yBAAA;AJkoCpB;AI9nCQ;EACI,cAAA;AJgoCZ;AI5nCQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yCAAA;EACA,+CAAA;EACA,SAAA;EACA,UAAA;AJ8nCZ;AI5nCQ;EACI,QAAA;EACA,UAAA;AJ8nCZ;;AIxnCA;EACI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qCAAA;EACA,kDAAA;EACA,SAAA;EACA,iBAAA;AJ2nCJ;;AIxnCA;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AJ2nCJ;AI1nCI;EAEI,kCAAA;EACA,yCAAA;AJ2nCR;AIxnCI;EAEI,kCAAA;EACA,qBAAA;EACA,yCAAA;AJynCR;AItnCI;EAEI,YAAA;EACA,oBAAA;EACA,6BAAA;AJunCR;;AIjnCA;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AJonCJ;AInnCI;EACI,8BAAA;EACA,yCAAA;EACA,iBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AJqnCR;AInnCI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;AJqnCR;AIpnCQ;EACI,yCAAA;AJsnCZ;AIpnCQ;EACI,WAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AJsnCZ;AIpnCQ;EACI,mBAAA;EACA,qCAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AJsnCZ;AIpnCQ;EACI,cAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AJsnCZ;;AK7uCE;EACE,QAlBG;ALkwCP;;AKjvCE;EACE,QAlBG;ALswCP;;AKrvCE;EACE,QAlBG;AL0wCP;;AKzvCE;EACE,SAlBG;AL8wCP;;AK7vCE;EACE,SAlBG;ALkxCP;;AKjwCE;EACE,SAlBG;ALsxCP;;AKrwCE;EACE,SAlBG;AL0xCP;;AKzwCE;EACE,SAlBG;AL8xCP;;AK7wCE;EACE,QAlBG;ALkyCP;;AKjxCE;EACE,SAlBG;ALsyCP;;AKrxCE;EACE,SAlBG;AL0yCP;;AKzxCE;EACE,SAlBG;AL8yCP;;AK7xCE;EACE,SAlBG;ALkzCP;;AKjxCE;EACE,kBAXO;AL+xCX;;AKrxCE;EACE,kBAXO;ALmyCX;;AKzxCE;EACE,kBAXO;ALuyCX;;AK7xCE;EACE,mBAXO;AL2yCX;;AKjyCE;EACE,mBAXO;AL+yCX;;AKryCE;EACE,oBAXO;ALmzCX;;AKvxCE;EACE,aAbO;ALuyCX;;AKxxCE;EACE,iBAhBO;AL2yCX;;AKzxCE;EACE,oBAnBO;AL+yCX;;AK1xCE;EACE,kBAtBO;ALmzCX;;AK3xCE;EACE,mBAzBO;ALuzCX;;AK3yCE;EACE,YAbO;AL2zCX;;AK5yCE;EACE,gBAhBO;AL+zCX;;AK7yCE;EACE,mBAnBO;ALm0CX;;AK9yCE;EACE,iBAtBO;ALu0CX;;AK/yCE;EACE,kBAzBO;AL20CX;;AK/zCE;EACE,YAbO;AL+0CX;;AKh0CE;EACE,gBAhBO;ALm1CX;;AKj0CE;EACE,mBAnBO;ALu1CX;;AKl0CE;EACE,iBAtBO;AL21CX;;AKn0CE;EACE,kBAzBO;AL+1CX;;AKn1CE;EACE,aAbO;ALm2CX;;AKp1CE;EACE,iBAhBO;ALu2CX;;AKr1CE;EACE,oBAnBO;AL22CX;;AKt1CE;EACE,kBAtBO;AL+2CX;;AKv1CE;EACE,mBAzBO;ALm3CX;;AKv2CE;EACE,aAbO;ALu3CX;;AKx2CE;EACE,iBAhBO;AL23CX;;AKz2CE;EACE,oBAnBO;AL+3CX;;AK12CE;EACE,kBAtBO;ALm4CX;;AK32CE;EACE,mBAzBO;ALu4CX;;AK33CE;EACE,aAbO;AL24CX;;AK53CE;EACE,iBAhBO;AL+4CX;;AK73CE;EACE,oBAnBO;ALm5CX;;AK93CE;EACE,kBAtBO;ALu5CX;;AK/3CE;EACE,mBAzBO;AL25CX;;AK/4CE;EACE,aAbO;AL+5CX;;AKh5CE;EACE,iBAhBO;ALm6CX;;AKj5CE;EACE,oBAnBO;ALu6CX;;AKl5CE;EACE,kBAtBO;AL26CX;;AKn5CE;EACE,mBAzBO;AL+6CX;;AKn6CE;EACE,aAbO;ALm7CX;;AKp6CE;EACE,iBAhBO;ALu7CX;;AKr6CE;EACE,oBAnBO;AL27CX;;AKt6CE;EACE,kBAtBO;AL+7CX;;AKv6CE;EACE,mBAzBO;ALm8CX;;AK73CA;EACI,qBAAA;ALg4CJ;;AK73CA;EACI,oBAAA;ALg4CJ;;AK73CA;EACI,kCAAA;ALg4CJ;;AK53CA;EACI,wBAAA;AL+3CJ;;AK53CA;EACI,wBAAA;AL+3CJ;;AK53CA;EACI,yBAAA;AL+3CJ;;AK53CA;EACI,yBAAA;AL+3CJ;;AK33CA;EACI,kBAAA;AL83CJ;;AK53CA;EACI,kBAAA;AL+3CJ;;AK73CA;EACI,aAAA;ALg4CJ;;AK93CA;EA/EI,aAAA;ALi9CJ;;AK93CA;EACI,cAAA;ALi4CJ;;AK93CA;EAnFI,oBAAA;ALq9CJ;;AK93CA;EAnFI,mBAoFwB;ALi4C5B;;AK93CA;EAvFI,2BAwFwB;ALi4C5B;;AK93CA;EA3FI,sBA4FwB;ALi4C5B;;AK93CA;EA/FI,8BAgGwB;ALi4C5B;;AK93CA;EA/FI,eAgGmB;ALi4CvB;;AK93CA;EAnGI,iBAoGmB;ALi4CvB;;AK93CA;EAvGI,uBAwGmB;ALi4CvB;;AK93CA;EAvGI,2BAwGyB;ALi4C7B;;AK93CA;EA3GI,yBA4GyB;ALi4C7B;;AK93CA;EA/GI,uBAgHyB;ALi4C7B;;AK93CA;EAnHI,8BAoHyB;ALi4C7B;;AK93CA;EAvHI,6BAwHyB;ALi4C7B;;AK93CA;EAvHI,uBAwHqB;ALi4CzB;;AK93CA;EA3HI,qBA4HqB;ALi4CzB;;AK93CA;EA/HI,mBAgIqB;ALi4CzB;;AK93CA;EAnII,qBAoIqB;ALi4CzB;;AK93CA;EAvII,oBAwIqB;ALi4CzB;;AK93CA;EAvII,yBAwIuB;ALi4C3B;;AK93CA;EA3II,uBA4IuB;ALi4C3B;;AK93CA;EA/II,qBAgJuB;ALi4C3B;;AK93CA;EAnJI,4BAoJuB;ALi4C3B;;AK93CA;EAvJI,2BAwJuB;ALi4C3B;;AK73CA;EAxJI,WAyJe;ALg4CnB;;AK73CA;EAvJI,YAwJgB;ALg4CpB;;AK73CA;EACI,gBAAA;ALg4CJ;;AK13CA;EACI,kBAAA;AL63CJ;AK53CI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,kDAAA;EACA,mBAAA;EACA,iDAAA;AL63CR;AK53CQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;AL83CZ;AK53CQ;EACI,2CAAA;AL83CZ;AK73CY;EACI,2CAAA;EACA,2BAAA;AL+3ChB;;AKx3CA;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AL23CJ;;AKv3CI;EACI,WAAA;EACA,YAAA;EACA,0CAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AL03CR;AKz3CQ;EACI,qCAAA;EACA,2CAAA;EACA,wCAAA;AL23CZ;AKx3CI;EACI,eAAA;AL03CR;;AKt3CA;EACI,eAAA;ALy3CJ;;AKt3CA;EACI,yBAAA;ALy3CJ;;AM9sDA;EACI,eAAA;EACA,gBAAA;EACA,yCAAA;EACA,8FAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;ANitDJ;AMhtDI;EACI,mCAAA;EACA,mCAAA;ANktDR;AMhtDI;EACI,gBAAA;EACA,2CAAA;ANktDR;AMhtDI;EACI,eAAA;ANktDR;AMhtDI;EACI,iBAAA;EACA,4CAAA;ANktDR;AM/sDI;EACI,gBAAA;EACA,wCAAA;ANitDR","sourcesContent":["@mixin headingTextDisplay($size, $weight, $lineheight, $color, $textalign, $opacity) {\n    font-size: $size;\n    font-weight: $weight;\n    line-height: $lineheight;\n    color: $color;\n    text-align: $textalign;\n    margin: 0;\n    opacity: $opacity;\n    // display: flex;\n    // align-items: center;\n    // gap: 6px;\n    i{\n        flex-shrink: 0;\n        cursor: pointer;\n        color: var(--AA-gloabl-text-color);\n        opacity: 0.5;\n    }\n    &.medium {\n        font-weight: 500;\n    }\n    &.semibold {\n        font-weight: 600;\n    }\n    &.bold {\n        font-weight: 700;\n    }\n    &.center{\n        text-align: center;\n    }\n}\n\n.aa-heading-two-xl {\n    letter-spacing: -0.02em;\n    @include headingTextDisplay(72px, 400, 90px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-heading-xl {\n    letter-spacing: -0.02em;\n    @include headingTextDisplay(60px, 400, 72px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-heading-lg {\n    letter-spacing: -0.96px;\n    @include headingTextDisplay(48px, 400, 60px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-heading-md {\n    @include headingTextDisplay(36px, 400, 44px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-heading-sm {\n    @include headingTextDisplay(36px, 400, 44px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-heading-xs {\n    @include headingTextDisplay(24px, 400, 32px, var(--AA-gloabl-text-color), start, 1);\n}\n\n// Text\n\n.aa-text-xl {\n    @include headingTextDisplay(20px, 400, 30px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-text-lg {\n    @include headingTextDisplay(18px, 400, 28px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-text-md {\n    @include headingTextDisplay(16px, 400, 24px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-text-sm {\n    @include headingTextDisplay(14px, 400, 20px, var(--AA-gloabl-text-color), start, 1);\n}\n\n.aa-text-xs {\n    @include headingTextDisplay(12px, 400, 18px, var(--AA-gloabl-text-color), start, 1);\n}\n.aa-text-xxs {\n    @include headingTextDisplay(10px, 400, 16px, var(--AA-gloabl-text-color), start, 1);\n}\n\n\n// Desc Text\n\n.aa-desc-xl {\n    @include headingTextDisplay(20px, 400, 30px, var(--AA-gloabl-text-color), start, 0.5);\n}\n\n.aa-desc-lg {\n    @include headingTextDisplay(18px, 400, 28px, var(--AA-gloabl-text-color), start, 0.5);\n}\n\n.aa-desc-md {\n    @include headingTextDisplay(16px, 400, 24px, var(--AA-gloabl-text-color), start, 0.5);\n}\n\n.aa-desc-sm {\n    @include headingTextDisplay(14px, 400, 20px, var(--AA-gloabl-text-color), start, 0.5);\n}\n\n.aa-desc-xs {\n    @include headingTextDisplay(12px, 400, 18px, var(--AA-gloabl-text-color), start, 0.5);\n}\n\n.aa-desc-xxs {\n    @include headingTextDisplay(10px, 400, 16px, var(--AA-gloabl-text-color), start, 0.5);\n}\n",".aa-heading-two-xl {\n  letter-spacing: -0.02em;\n  font-size: 72px;\n  font-weight: 400;\n  line-height: 90px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-two-xl i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-two-xl.medium {\n  font-weight: 500;\n}\n.aa-heading-two-xl.semibold {\n  font-weight: 600;\n}\n.aa-heading-two-xl.bold {\n  font-weight: 700;\n}\n.aa-heading-two-xl.center {\n  text-align: center;\n}\n\n.aa-heading-xl {\n  letter-spacing: -0.02em;\n  font-size: 60px;\n  font-weight: 400;\n  line-height: 72px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-xl i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-xl.medium {\n  font-weight: 500;\n}\n.aa-heading-xl.semibold {\n  font-weight: 600;\n}\n.aa-heading-xl.bold {\n  font-weight: 700;\n}\n.aa-heading-xl.center {\n  text-align: center;\n}\n\n.aa-heading-lg {\n  letter-spacing: -0.96px;\n  font-size: 48px;\n  font-weight: 400;\n  line-height: 60px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-lg i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-lg.medium {\n  font-weight: 500;\n}\n.aa-heading-lg.semibold {\n  font-weight: 600;\n}\n.aa-heading-lg.bold {\n  font-weight: 700;\n}\n.aa-heading-lg.center {\n  text-align: center;\n}\n\n.aa-heading-md {\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 44px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-md i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-md.medium {\n  font-weight: 500;\n}\n.aa-heading-md.semibold {\n  font-weight: 600;\n}\n.aa-heading-md.bold {\n  font-weight: 700;\n}\n.aa-heading-md.center {\n  text-align: center;\n}\n\n.aa-heading-sm {\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 44px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-sm i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-sm.medium {\n  font-weight: 500;\n}\n.aa-heading-sm.semibold {\n  font-weight: 600;\n}\n.aa-heading-sm.bold {\n  font-weight: 700;\n}\n.aa-heading-sm.center {\n  text-align: center;\n}\n\n.aa-heading-xs {\n  font-size: 24px;\n  font-weight: 400;\n  line-height: 32px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-heading-xs i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-heading-xs.medium {\n  font-weight: 500;\n}\n.aa-heading-xs.semibold {\n  font-weight: 600;\n}\n.aa-heading-xs.bold {\n  font-weight: 700;\n}\n.aa-heading-xs.center {\n  text-align: center;\n}\n\n.aa-text-xl {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-xl i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-xl.medium {\n  font-weight: 500;\n}\n.aa-text-xl.semibold {\n  font-weight: 600;\n}\n.aa-text-xl.bold {\n  font-weight: 700;\n}\n.aa-text-xl.center {\n  text-align: center;\n}\n\n.aa-text-lg {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-lg i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-lg.medium {\n  font-weight: 500;\n}\n.aa-text-lg.semibold {\n  font-weight: 600;\n}\n.aa-text-lg.bold {\n  font-weight: 700;\n}\n.aa-text-lg.center {\n  text-align: center;\n}\n\n.aa-text-md {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-md i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-md.medium {\n  font-weight: 500;\n}\n.aa-text-md.semibold {\n  font-weight: 600;\n}\n.aa-text-md.bold {\n  font-weight: 700;\n}\n.aa-text-md.center {\n  text-align: center;\n}\n\n.aa-text-sm {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-sm i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-sm.medium {\n  font-weight: 500;\n}\n.aa-text-sm.semibold {\n  font-weight: 600;\n}\n.aa-text-sm.bold {\n  font-weight: 700;\n}\n.aa-text-sm.center {\n  text-align: center;\n}\n\n.aa-text-xs {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-xs i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-xs.medium {\n  font-weight: 500;\n}\n.aa-text-xs.semibold {\n  font-weight: 600;\n}\n.aa-text-xs.bold {\n  font-weight: 700;\n}\n.aa-text-xs.center {\n  text-align: center;\n}\n\n.aa-text-xxs {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 1;\n}\n.aa-text-xxs i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-text-xxs.medium {\n  font-weight: 500;\n}\n.aa-text-xxs.semibold {\n  font-weight: 600;\n}\n.aa-text-xxs.bold {\n  font-weight: 700;\n}\n.aa-text-xxs.center {\n  text-align: center;\n}\n\n.aa-desc-xl {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 30px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-xl i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-xl.medium {\n  font-weight: 500;\n}\n.aa-desc-xl.semibold {\n  font-weight: 600;\n}\n.aa-desc-xl.bold {\n  font-weight: 700;\n}\n.aa-desc-xl.center {\n  text-align: center;\n}\n\n.aa-desc-lg {\n  font-size: 18px;\n  font-weight: 400;\n  line-height: 28px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-lg i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-lg.medium {\n  font-weight: 500;\n}\n.aa-desc-lg.semibold {\n  font-weight: 600;\n}\n.aa-desc-lg.bold {\n  font-weight: 700;\n}\n.aa-desc-lg.center {\n  text-align: center;\n}\n\n.aa-desc-md {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-md i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-md.medium {\n  font-weight: 500;\n}\n.aa-desc-md.semibold {\n  font-weight: 600;\n}\n.aa-desc-md.bold {\n  font-weight: 700;\n}\n.aa-desc-md.center {\n  text-align: center;\n}\n\n.aa-desc-sm {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-sm i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-sm.medium {\n  font-weight: 500;\n}\n.aa-desc-sm.semibold {\n  font-weight: 600;\n}\n.aa-desc-sm.bold {\n  font-weight: 700;\n}\n.aa-desc-sm.center {\n  text-align: center;\n}\n\n.aa-desc-xs {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-xs i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-xs.medium {\n  font-weight: 500;\n}\n.aa-desc-xs.semibold {\n  font-weight: 600;\n}\n.aa-desc-xs.bold {\n  font-weight: 700;\n}\n.aa-desc-xs.center {\n  text-align: center;\n}\n\n.aa-desc-xxs {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 16px;\n  color: var(--AA-gloabl-text-color);\n  text-align: start;\n  margin: 0;\n  opacity: 0.5;\n}\n.aa-desc-xxs i {\n  flex-shrink: 0;\n  cursor: pointer;\n  color: var(--AA-gloabl-text-color);\n  opacity: 0.5;\n}\n.aa-desc-xxs.medium {\n  font-weight: 500;\n}\n.aa-desc-xxs.semibold {\n  font-weight: 600;\n}\n.aa-desc-xxs.bold {\n  font-weight: 700;\n}\n.aa-desc-xxs.center {\n  text-align: center;\n}\n\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n* {\n  font-family: var(--AA-font-family);\n  box-sizing: border-box;\n}\n\nbutton {\n  cursor: pointer;\n}\n\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ncaption,\ntbody,\ntfoot,\nthead,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  vertical-align: baseline;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  text-align: start;\n}\n\nhtml {\n  overflow: hidden;\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  line-height: normal;\n  padding: 20px;\n}\n\n.agentassist-widget-main-chat-container-wrapper {\n  color: var(--AA-gloabl-text-color);\n}\n\n:focus-visible {\n  outline-color: var(--AA-global-theme-bg);\n  outline-offset: 1px;\n  outline-style: auto;\n}\n\nbody::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n  cursor: pointer;\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  cursor: pointer;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: var(--AA-gloabl-bg-secondary);\n  border-radius: 7px;\n  transition: background-color 0.2s linear, width 0.2s ease-in-out;\n  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;\n}\n::-webkit-scrollbar-thumb:hover {\n  background-color: var(--AA-gloabl-border);\n}\n\nbody {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: normal;\n  -webkit-text-size-adjust: 100%;\n}\n\n.agentassist-widget-main-chat-container-wrapper {\n  color: var(--AA-gloabl-text-color);\n  background-color: var(--AA-global-white-bg);\n}\n\nh6, h5, h4, h3, h2, h1 {\n  margin-top: 0;\n  margin-bottom: 0px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.paragraph {\n  margin: 0;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--AA-gloabl-text-color);\n}\n\n.paragraph.semibold {\n  font-weight: 600;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.w-100 {\n  width: 100%;\n}\n\np {\n  margin: 0;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\n.disabled-msg {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\nsub,\nsup {\n  position: relative;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: var(--AA-global-theme-text-color);\n  text-decoration: none;\n  cursor: pointer;\n}\na:hover {\n  color: var(--AA-global-theme-text-color);\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\nfigure {\n  margin: 0;\n  line-height: 0;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\nth {\n  font-weight: 500;\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton:disabled,\n[type=button]:disabled,\n[type=reset]:disabled,\n[type=submit]:disabled {\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\niframe {\n  border: 0;\n}\n\n[hidden] {\n  display: none !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.aa-d-none {\n  display: none !important;\n}\n\n.aa-hidden {\n  display: none !important;\n}\n\n.more-link-text {\n  cursor: pointer;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  color: var(--AA-global-theme-text-color);\n}\n\n.aa-solidbtn {\n  border-radius: 4px;\n  border: 1px solid var(--AA-gloabl-border);\n  background: var(--AA-global-white-bg);\n  padding: 5px 11px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 24px;\n}\n\n.aa-btn-link {\n  color: var(--AA-global-theme-text-color);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  cursor: pointer;\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n\n.aa_btn {\n  padding: 4px 14px;\n  height: 30px;\n  border-radius: 4px;\n  border: 1px solid var(--AA-gloabl-border);\n  background: var(--AA-global-white-bg);\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: var(--AA-gloabl-text-color);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  transition: 0.2s all ease;\n}\n.aa_btn.w-100 {\n  width: 100%;\n}\n.aa_btn:disabled {\n  opacity: 0.3;\n}\n\n.aa-danger-btn {\n  background: #D92D20;\n  border-color: #D92D20;\n  color: #fff;\n}\n.aa-danger-btn:hover {\n  background: #b42318;\n  border: 1px solid #b42318;\n}\n\n.primaryBtn {\n  border: 1px solid var(--AA-global-theme-text-color);\n  background: var(--AA-global-theme-bg);\n  color: var(--AA-global-white-color);\n}\n.primaryBtn:focus {\n  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n.primaryBtn:active {\n  box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n.primaryBtn:hover {\n  border: 1px solid var(--AA-global-theme-bg);\n  background: var(--AA-global-theme-bg);\n}\n\n.aa-p-0 {\n  padding: 0 !important;\n}\n\n.h_100 {\n  height: 100%;\n}\n\n@keyframes bottomToTopMove {\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n    display: none;\n  }\n  60% {\n    display: none;\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    display: block;\n    transform: translateY(0%);\n  }\n}\n.animate-compo-slide-up-wrapper {\n  height: 100%;\n  animation-name: bottomToTopMove;\n  animation-duration: 0.5s;\n  animation-fill-mode: forwards;\n}\n\n:root {\n  --AA-font-family: \"Inter\";\n  --AA-primary-color:#2970FF;\n  --AA-secondary-color:#f8fafc;\n  --AA-primary-text:#101828;\n  --AA-secondary-text:#FFFFFF;\n  --AA-body-background:#FFFFFF;\n  --AA-warning-color:#D92D20;\n  --AA-global-theme-bg:var(--AA-primary-color);\n  --AA-global-theme-text-color:var(--AA-primary-color);\n  --AA-gloabl-bg-secondary:var(--AA-secondary-color);\n  --AA-global-white-color:var(--AA-secondary-text);\n  --AA-global-white-bg:var(--AA-body-background);\n  --AA-gloabl-text-color:var(--AA-primary-text);\n  --AA-gloabl-text-desc-color:var(--AA-primary-text);\n  --AA-gloabl-border:var(--AA-secondary-color);\n  --AA-gloabl-scrollbar-bg:var(--AA-secondary-color);\n  --AA-static-border:var(--AA-gloabl-border);\n  --sdk-global-theme-color:var(--AA-primary-color) !important;\n  --sdk-gloabl-bg-secondary:var(--AA-secondary-color) !important;\n  --sdk-global_white:var(--AA-body-background) !important;\n  --sdk-global-white-bg:var(--AA-body-background) !important;\n  --sdk-gloabl-text-color:var(--AA-primary-text) !important;\n  --sdk-gloabl-text-desc-color:var(--AA-secondary-text) !important;\n  --sdk-gloabl-border-color:var(--AA-secondary-color) !important;\n  --sdk-scrollbar-bg:var(--AA-secondary-color);\n}\n\n.aa-toggle-switch {\n  position: relative;\n  display: block;\n}\n.aa-toggle-switch input {\n  opacity: 0;\n  position: absolute;\n  z-index: 9;\n  cursor: pointer;\n  width: 28px;\n  height: 16px;\n  left: 0;\n  top: 0px;\n  line-height: normal;\n  font-size: 0;\n}\n.aa-toggle-switch input:checked + .aa-slider .slide-parent .slider-btn {\n  background-color: var(--AA-global-theme-bg);\n}\n.aa-toggle-switch input:checked + .aa-slider .slide-parent .slider-btn::before {\n  -webkit-transform: translateX(12px);\n  -ms-transform: translateX(12px);\n  transform: translateX(12px);\n}\n.aa-toggle-switch input:checked + .aa-slider span {\n  font-size: 12px;\n  color: var(--AA-gloabl-text-color);\n  cursor: pointer;\n  font-weight: 500;\n}\n.aa-toggle-switch input:checked + .aa-slider span.enabled {\n  display: block;\n}\n.aa-toggle-switch input:checked + .aa-slider span.disabled {\n  display: none;\n}\n.aa-toggle-switch input:checked:disabled + .aa-slider .slide-parent .slider-btn {\n  opacity: 0.5;\n}\n.aa-toggle-switch input:disabled {\n  cursor: auto;\n}\n.aa-toggle-switch input:disabled + .aa-slider .slide-parent .slider-btn {\n  opacity: 0.5;\n}\n.aa-toggle-switch .aa-slider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  background: transparent;\n  padding: 0;\n  border: 0;\n  outline: 0;\n}\n.aa-toggle-switch .aa-slider .slide-parent {\n  position: relative;\n  width: 28px;\n  height: 16px;\n}\n.aa-toggle-switch .aa-slider .slide-parent .slider-btn {\n  position: absolute;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  transition: 0.4s;\n  border-radius: 10px;\n  background: var(--AA-global-white-bg);\n  border: 0;\n  padding: 0;\n  outline: 0;\n}\n.aa-toggle-switch .aa-slider .slide-parent .slider-btn:focus {\n  box-shadow: 0px 0px 0px 4px #EFF4FF;\n}\n.aa-toggle-switch .aa-slider .slide-parent .slider-btn::before {\n  position: absolute;\n  content: \"\";\n  height: 12px;\n  width: 12px;\n  top: 2px;\n  left: 2px;\n  right: 0;\n  background-color: var(--AA-global-white-bg);\n  transition: 0.4s;\n  border-radius: 50%;\n  filter: drop-shadow(0px 0.778px 1.556px rgba(16, 24, 40, 0.06)) drop-shadow(0px 0.778px 2.333px rgba(16, 24, 40, 0.1));\n}\n.aa-toggle-switch .aa-slider span {\n  font-size: 12px;\n  color: var(--AA-gloabl-text-color);\n  cursor: pointer;\n  font-weight: 500;\n}\n.aa-toggle-switch .aa-slider span.no {\n  color: var(--AA-gloabl-text-color);\n}\n.aa-toggle-switch .aa-slider span.enabled {\n  color: var(--AA-gloabl-text-color);\n  display: none;\n}\n.aa-toggle-switch .aa-slider span.disabled {\n  display: block;\n}\n\n.aa-dropdown {\n  position: relative;\n}\n.aa-dropdown .aa-dropdown-toggle {\n  white-space: nowrap;\n}\n.aa-dropdown.show .aa-dropdown-toggle svg.arrow-icon {\n  transform: rotate(180deg);\n}\n.aa-dropdown.show .aa-dropdown-content {\n  display: block;\n}\n.aa-dropdown.aa-elipse-dropdown .aa-dropdown-toggle {\n  display: flex;\n  width: 22px;\n  height: 22px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 4px;\n  background: var(--AA-gloabl-bg-secondary);\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);\n  border: 0;\n  padding: 0;\n}\n.aa-dropdown.aa-elipse-dropdown .aa-dropdown-content {\n  right: 0;\n  padding: 0;\n}\n\n.aa-dropdown-content {\n  position: absolute;\n  z-index: 1000;\n  display: none;\n  min-width: auto;\n  margin: 0;\n  color: var(--AA-gloabl-text-color);\n  text-align: left;\n  list-style: none;\n  background-clip: padding-box;\n  border-radius: 8px;\n  background: var(--AA-global-white-bg);\n  box-shadow: 0px 4px 8px 0px rgba(32, 33, 36, 0.15);\n  border: 0;\n  padding: 8px 12px;\n}\n\n.aa-dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 8px 14px;\n  clear: both;\n  text-align: inherit;\n  text-decoration: none;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  color: var(--AA-gloabl-text-color);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  border-radius: 6px;\n}\n.aa-dropdown-item:hover, .aa-dropdown-item:focus {\n  color: var(--AA-gloabl-text-color);\n  background: var(--AA-gloabl-bg-secondary);\n}\n.aa-dropdown-item.active, .aa-dropdown-item:active {\n  color: var(--AA-gloabl-text-color);\n  text-decoration: none;\n  background: var(--AA-gloabl-bg-secondary);\n}\n.aa-dropdown-item.disabled, .aa-dropdown-item:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.playbook-dropdown-content {\n  min-width: 250px;\n  max-height: 300px;\n  overflow: auto;\n  max-width: 350px;\n}\n.playbook-dropdown-content .heading-text-scripts {\n  border-radius: 8px 8px 0px 0px;\n  background: var(--AA-gloabl-bg-secondary);\n  padding: 8px 10px;\n  color: var(--AA-gloabl-text-color);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n}\n.playbook-dropdown-content .aa-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin: 1px 0;\n  white-space: normal;\n}\n.playbook-dropdown-content .aa-dropdown-item.selected {\n  background: var(--AA-gloabl-bg-secondary);\n}\n.playbook-dropdown-content .aa-dropdown-item p {\n  width: 100%;\n  color: var(--AA-gloabl-text-color);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.playbook-dropdown-content .aa-dropdown-item .primaryBtn {\n  border-radius: 16px;\n  background: var(--AA-global-theme-bg);\n  color: var(--AA-global-white-color);\n  font-size: 12px;\n  font-weight: 500;\n  height: 22px;\n  padding: 0 8px;\n  flex-shrink: 0;\n}\n.playbook-dropdown-content .aa-dropdown-item span {\n  flex-shrink: 0;\n  color: var(--AA-gloabl-text-desc-color);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  opacity: 0.8;\n}\n\n.a-gap-4 {\n  gap: 4px;\n}\n\n.a-gap-6 {\n  gap: 6px;\n}\n\n.a-gap-8 {\n  gap: 8px;\n}\n\n.a-gap-10 {\n  gap: 10px;\n}\n\n.a-gap-12 {\n  gap: 12px;\n}\n\n.a-gap-16 {\n  gap: 16px;\n}\n\n.a-gap-20 {\n  gap: 20px;\n}\n\n.a-gap-24 {\n  gap: 24px;\n}\n\n.a-gap-sm {\n  gap: 8px;\n}\n\n.a-gap-md {\n  gap: 16px;\n}\n\n.a-gap-lg {\n  gap: 24px;\n}\n\n.a-gap-xl {\n  gap: 32px;\n}\n\n.a-gap-xxl {\n  gap: 48px;\n}\n\n.a-radius-4 {\n  border-radius: 4px;\n}\n\n.a-radius-6 {\n  border-radius: 6px;\n}\n\n.a-radius-8 {\n  border-radius: 8px;\n}\n\n.a-radius-12 {\n  border-radius: 12px;\n}\n\n.a-radius-16 {\n  border-radius: 16px;\n}\n\n.a-radius-999 {\n  border-radius: 999px;\n}\n\n.a-padding-default {\n  padding: 24px;\n}\n\n.a-padding-default-top {\n  padding-top: 24px;\n}\n\n.a-padding-default-bottom {\n  padding-bottom: 24px;\n}\n\n.a-padding-default-left {\n  padding-left: 24px;\n}\n\n.a-padding-default-right {\n  padding-right: 24px;\n}\n\n.a-padding-xs {\n  padding: 4px;\n}\n\n.a-padding-xs-top {\n  padding-top: 4px;\n}\n\n.a-padding-xs-bottom {\n  padding-bottom: 4px;\n}\n\n.a-padding-xs-left {\n  padding-left: 4px;\n}\n\n.a-padding-xs-right {\n  padding-right: 4px;\n}\n\n.a-padding-sm {\n  padding: 8px;\n}\n\n.a-padding-sm-top {\n  padding-top: 8px;\n}\n\n.a-padding-sm-bottom {\n  padding-bottom: 8px;\n}\n\n.a-padding-sm-left {\n  padding-left: 8px;\n}\n\n.a-padding-sm-right {\n  padding-right: 8px;\n}\n\n.a-padding-smm {\n  padding: 10px;\n}\n\n.a-padding-smm-top {\n  padding-top: 10px;\n}\n\n.a-padding-smm-bottom {\n  padding-bottom: 10px;\n}\n\n.a-padding-smm-left {\n  padding-left: 10px;\n}\n\n.a-padding-smm-right {\n  padding-right: 10px;\n}\n\n.a-padding-md {\n  padding: 12px;\n}\n\n.a-padding-md-top {\n  padding-top: 12px;\n}\n\n.a-padding-md-bottom {\n  padding-bottom: 12px;\n}\n\n.a-padding-md-left {\n  padding-left: 12px;\n}\n\n.a-padding-md-right {\n  padding-right: 12px;\n}\n\n.a-padding-lg {\n  padding: 16px;\n}\n\n.a-padding-lg-top {\n  padding-top: 16px;\n}\n\n.a-padding-lg-bottom {\n  padding-bottom: 16px;\n}\n\n.a-padding-lg-left {\n  padding-left: 16px;\n}\n\n.a-padding-lg-right {\n  padding-right: 16px;\n}\n\n.a-padding-xl {\n  padding: 20px;\n}\n\n.a-padding-xl-top {\n  padding-top: 20px;\n}\n\n.a-padding-xl-bottom {\n  padding-bottom: 20px;\n}\n\n.a-padding-xl-left {\n  padding-left: 20px;\n}\n\n.a-padding-xl-right {\n  padding-right: 20px;\n}\n\n.a-padding-xxl {\n  padding: 24px;\n}\n\n.a-padding-xxl-top {\n  padding-top: 24px;\n}\n\n.a-padding-xxl-bottom {\n  padding-bottom: 24px;\n}\n\n.a-padding-xxl-left {\n  padding-left: 24px;\n}\n\n.a-padding-xxl-right {\n  padding-right: 24px;\n}\n\n.a-p-0 {\n  padding: 0 !important;\n}\n\n.a-m-0 {\n  margin: 0 !important;\n}\n\n.a-mb-8 {\n  margin-bottom: var(--default, 8px);\n}\n\n.a-gap-4 {\n  gap: var(--default, 4px);\n}\n\n.a-gap-8 {\n  gap: var(--default, 8px);\n}\n\n.a-gap-12 {\n  gap: var(--default, 12px);\n}\n\n.a-gap-16 {\n  gap: var(--default, 16px);\n}\n\n.a-position-relative {\n  position: relative;\n}\n\n.a-position-absolute {\n  position: absolute;\n}\n\n.a-d-none {\n  display: none;\n}\n\n.a-flex {\n  display: flex;\n}\n\n.a-flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.a-flex-inline {\n  display: inline-flex;\n}\n\n.a-flex-row {\n  flex-direction: row;\n}\n\n.a-flex-row-reverse {\n  flex-direction: row-reverse;\n}\n\n.a-flex-column {\n  flex-direction: column;\n}\n\n.a-flex-column-reverse {\n  flex-direction: column-reverse;\n}\n\n.a-flex-wrap {\n  flex-wrap: wrap;\n}\n\n.a-flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.a-flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n\n.a-justify-content-start {\n  justify-content: flex-start;\n}\n\n.a-justify-content-end {\n  justify-content: flex-end;\n}\n\n.a-justify-content-center {\n  justify-content: center;\n}\n\n.a-justify-content-between {\n  justify-content: space-between;\n}\n\n.a-justify-content-around {\n  justify-content: space-around;\n}\n\n.a-align-items-start {\n  align-items: flex-start;\n}\n\n.a-align-items-end {\n  align-items: flex-end;\n}\n\n.a-align-items-center {\n  align-items: center;\n}\n\n.a-align-items-baseline {\n  align-items: baseline;\n}\n\n.a-align-items-stretch {\n  align-items: stretch;\n}\n\n.a-align-content-start {\n  align-content: flex-start;\n}\n\n.a-align-content-end {\n  align-content: flex-end;\n}\n\n.a-align-content-center {\n  align-content: center;\n}\n\n.a-align-content-between {\n  align-content: space-between;\n}\n\n.a-align-content-around {\n  align-content: space-around;\n}\n\n.a-width-100 {\n  width: 100%;\n}\n\n.a-height-100 {\n  height: 100%;\n}\n\n.a-overflow-hidden {\n  overflow: hidden;\n}\n\n.a-form-checkbox-switch {\n  position: relative;\n}\n.a-form-checkbox-switch input {\n  width: 28px;\n  height: 16px;\n  appearance: none;\n  border: 1px solid var(--AA-static-border, #E4E7EC);\n  border-radius: 16px;\n  transition: background-position 0.15s ease-in-out;\n}\n.a-form-checkbox-switch input + .a-form-checkbox-switch-round {\n  width: 10px;\n  height: 10px;\n  border-radius: 16px;\n  background-color: var(--AA-static-border, #E4E7EC);\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.15s ease-in-out;\n}\n.a-form-checkbox-switch input:checked {\n  background-color: var(--AA-global-theme-bg);\n}\n.a-form-checkbox-switch input:checked + .a-form-checkbox-switch-round {\n  background-color: var(--AA-global-white-bg);\n  transform: translateX(12px);\n}\n\n.badge-text {\n  height: 16px;\n  padding: 2px 8px;\n  border-radius: 16px;\n  background: var(--AA-gloabl-bg-secondary);\n  color: var(--AA-gloabl-text-color);\n  text-align: center;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.radio-check-form input {\n  width: 16px;\n  height: 16px;\n  outline: 1px solid var(--AA-static-border);\n  appearance: none;\n  border-radius: 100%;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.radio-check-form input:checked {\n  background: var(--AA-global-theme-bg);\n  border: 4px solid var(--AA-global-white-bg);\n  outline-color: var(--AA-global-theme-bg);\n}\n.radio-check-form label {\n  cursor: pointer;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.a-text-uppercase {\n  text-transform: uppercase;\n}\n\n.aa-tooltip {\n  position: fixed;\n  max-width: 300px;\n  border: 0px solid var(--AA-gloabl-border);\n  box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n  background: var(--AA-global-white-bg);\n  border-radius: 8px;\n  padding: 9px 12px;\n  color: var(--AA-gloabl-text-color);\n  text-align: center;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 18px;\n  min-width: 150px;\n  z-index: 9999;\n}\n.aa-tooltip.aa-custom-tooltip {\n  background: var(--AA-primary-color);\n  color: var(--AA-global-white-color);\n}\n.aa-tooltip.tooltip-top {\n  margin-top: -5px;\n  transform: translate(-50%, -50%) !important;\n}\n.aa-tooltip.tooltip-bottom {\n  margin-top: 5px;\n}\n.aa-tooltip.tooltip-left {\n  margin-left: -5px;\n  transform: translate(-100%, -50%) !important;\n}\n.aa-tooltip.tooltip-right {\n  margin-left: 5px;\n  transform: translate(0, -50%) !important;\n}","// Reset CSS\n\n\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n* {\n    font-family: var(--AA-font-family);\n    box-sizing: border-box;\n}\n\nbutton {\n    cursor: pointer;\n}\n\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ncaption,\ntbody,\ntfoot,\nthead,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    // font-size: 100%;\n    vertical-align: baseline;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    text-align: start;\n}\n\nhtml {\n    overflow: hidden;\n    height: 100%;\n}\n\nbody {\n    height: 100%;\n    line-height: normal;\n    padding: 20px;\n}\n\n.agentassist-widget-main-chat-container-wrapper {\n    color: var(--AA-gloabl-text-color);\n}\n\n:focus-visible {\n    outline-color: var(--AA-global-theme-bg);\n    outline-offset: 1px;\n    outline-style: auto;\n}\n\nbody::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    cursor: pointer;\n}\n\n::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    cursor: pointer;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: var(--AA-gloabl-bg-secondary);\n    border-radius: 7px;\n    transition: background-color 0.2s linear, width 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;\n\n    &:hover {\n        background-color: var(--AA-gloabl-border);\n    }\n}\n\nbody {\n    margin: 0; // 1\n    font-size: 14px;\n    font-weight: 400;\n    line-height: normal;\n    -webkit-text-size-adjust: 100%;\n}\n\n.agentassist-widget-main-chat-container-wrapper{\n    color: var(--AA-gloabl-text-color);\n    background-color: var(--AA-global-white-bg);\n}\n\n\n\n%heading {\n    margin-top: 0; // 1\n    margin-bottom: 0px;\n    font-weight: 400;\n    line-height: normal;\n}\n\nh1 {\n    @extend %heading;\n}\n\nh2 {\n    @extend %heading;\n}\n\nh3 {\n    @extend %heading;\n}\n\nh4 {\n    @extend %heading;\n}\n\nh5 {\n    @extend %heading;\n}\n\nh6 {\n    @extend %heading;\n}\n\n%paragraph {\n    margin: 0;\n    font-weight: 400;\n    line-height: 20px;\n    color: var(--AA-gloabl-text-color);\n}\n\n.paragraph {\n    @extend %paragraph;\n\n    &.semibold {\n        font-weight: 600\n    }\n}\n\n.h-100 {\n    height: 100%;\n}\n\n.w-100 {\n    width: 100%;\n}\n\np {\n    margin: 0;\n}\n\n// Lists\n\nol,\nul {\n    padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n    margin-top: 0;\n    margin-bottom: 1rem;\n}\n\n.disabled-msg {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n    margin-bottom: 0;\n}\n\n// 1. Undo browser default\n\ndd {\n    margin-bottom: .5rem;\n    margin-left: 0; // 1\n}\n\nb,\nstrong {\n    font-weight: 700;\n}\n\nsub,\nsup {\n    position: relative;\n    line-height: 0;\n    vertical-align: baseline;\n}\n\nsub {\n    bottom: -.25em;\n}\n\nsup {\n    top: -.5em;\n}\n\n// Links\n\na {\n    color: var(--AA-global-theme-text-color);\n    text-decoration: none;\n    cursor: pointer;\n\n    &:hover {\n        color: var(--AA-global-theme-text-color);\n    }\n}\n\na:not([href]):not([class]) {\n\n    &,\n    &:hover {\n        color: inherit;\n        text-decoration: none;\n    }\n}\n\nfigure {\n    margin: 0;\n    line-height: 0;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n    vertical-align: middle;\n}\n\ntable {\n    caption-side: bottom;\n    border-collapse: collapse;\n}\n\nth {\n    font-weight: 500; // 1\n    text-align: inherit; // 2\n    text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n}\n\n\nlabel {\n    display: inline-block; // 1\n}\n\nbutton:focus:not(:focus-visible) {\n    outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n    margin: 0; // 1\n    font-family: inherit;\n    line-height: inherit;\n}\n\nbutton,\nselect {\n    text-transform: none;\n}\n\n[role=\"button\"] {\n    cursor: pointer;\n}\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n    display: none !important;\n}\n\nbutton,\n[type=\"button\"],\n// 1\n[type=\"reset\"],\n[type=\"submit\"] {\n    -webkit-appearance: button; // 2\n    cursor: pointer;\n\n    &:disabled {\n        opacity: 0.3;\n        pointer-events: none;\n    }\n}\n\n::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n}\n\ntextarea {\n    resize: vertical; // 1\n}\n\n.text-truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n    padding: 0;\n}\n\n::-webkit-inner-spin-button {\n    height: auto;\n}\n\n[type=\"search\"] {\n    -webkit-appearance: textfield; // 1\n    outline-offset: -2px; // 2\n}\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n    -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n    padding: 0;\n}\n\n::file-selector-button {\n    font: inherit; // 1\n    -webkit-appearance: button; // 2\n}\n\niframe {\n    border: 0;\n}\n\n[hidden] {\n    display: none !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n    -moz-appearance: textfield;\n}\n\n.aa-d-none{\n    display: none !important;\n}\n.aa-hidden{\n    display: none !important;\n}\n\n.more-link-text{\n    cursor: pointer;\n    border: 0;\n    background: transparent;\n    padding: 0;\n    color: var(--AA-global-theme-text-color);\n}\n\n.aa-solidbtn{\n    border-radius: 4px;\n    border: 1px solid var(--AA-gloabl-border);\n    background: var(--AA-global-white-bg);\n    padding: 5px 11px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 24px;\n}\n\n\n.aa-btn-link{\n    color: var(--AA-global-theme-text-color);\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    padding: 0;\n}\n\n.aa_btn{\n    padding: 4px 14px;\n    height: 30px;\n    border-radius: 4px;\n    border: 1px solid var(--AA-gloabl-border);\n    background: var(--AA-global-white-bg);\n    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    color: var(--AA-gloabl-text-color);\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    transition: 0.2s all ease;\n    &.w-100{\n      width: 100%;\n    }\n    &:disabled{\n      opacity: 0.3;\n    }\n}\n\n.aa-danger-btn{\n    background: #D92D20;\n    border-color: #D92D20;\n    color: #fff;\n    &:hover{\n        background: #b42318;\n        border: 1px solid #b42318;\n    }\n}\n\n\n.primaryBtn{\n    border: 1px solid var(--AA-global-theme-text-color);\n    background: var(--AA-global-theme-bg);\n    color: var(--AA-global-white-color);\n    &:focus{\n      box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    }\n    &:active{\n      box-shadow: 0px 0px 0px 4px #EFF4FF, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n    }\n    &:hover{\n      border: 1px solid var(--AA-global-theme-bg);\n      background: var(--AA-global-theme-bg);\n    }\n}\n\n.aa-p-0{\n    padding: 0 !important;\n}\n\n\n.h_100{\n    height: 100%;\n}\n@keyframes bottomToTopMove {\n    0% {\n      opacity: 0;\n      transform: translateY(100%);\n      display: none;\n    }\n    60%{\n        display: none;\n        opacity: 0;\n    }\n    100% {\n      opacity: 1;\n      display: block;\n      transform: translateY(0%);\n    }\n}\n\n.animate-compo-slide-up-wrapper{\n    height: 100%;\n    animation-name: bottomToTopMove;\n    animation-duration: 0.5s;\n    animation-fill-mode: forwards;\n\n}","// Variables\n\n\n:root{\n  --AA-font-family: \"Inter\";   // \"Inter\";\n\n  // Main 4 colors pallet\n  --AA-primary-color:#2970FF;\n  --AA-secondary-color:#f8fafc;\n  --AA-primary-text:#101828;\n  --AA-secondary-text:#FFFFFF;\n\n  --AA-body-background:#FFFFFF;\n  --AA-warning-color:#D92D20;\n\n  // Dependent Color\n  --AA-global-theme-bg:var(--AA-primary-color);\n  --AA-global-theme-text-color:var(--AA-primary-color);\n  --AA-gloabl-bg-secondary:var(--AA-secondary-color);\n  --AA-global-white-color:var(--AA-secondary-text);\n  --AA-global-white-bg:var(--AA-body-background);\n  --AA-gloabl-text-color:var(--AA-primary-text);\n  --AA-gloabl-text-desc-color:var(--AA-primary-text);\n  --AA-gloabl-border:var(--AA-secondary-color);\n  --AA-gloabl-scrollbar-bg:var(--AA-secondary-color);\n\n\n\n  --AA-static-border:var(--AA-gloabl-border);\n\n\n  // override sdk color variabls\n\n  --sdk-global-theme-color:var(--AA-primary-color) !important;\n  --sdk-gloabl-bg-secondary:var(--AA-secondary-color) !important;\n  --sdk-global_white:var(--AA-body-background) !important;\n  --sdk-global-white-bg:var(--AA-body-background) !important;\n  --sdk-gloabl-text-color:var(--AA-primary-text) !important;\n  --sdk-gloabl-text-desc-color:var(--AA-secondary-text) !important;\n  --sdk-gloabl-border-color:var(--AA-secondary-color) !important;\n  --sdk-scrollbar-bg:var(--AA-secondary-color);\n}",".aa-toggle-switch {\n    position: relative;\n    display: block;\n    input{\n        opacity: 0;\n        position: absolute;\n        z-index: 9;\n        cursor: pointer;\n        width: 28px;\n        height: 16px;\n        left: 0;\n        top: 0px;\n        line-height: normal;\n        font-size: 0;\n        &:checked{\n            + .aa-slider{\n                .slide-parent{\n                    .slider-btn{\n                        background-color: var(--AA-global-theme-bg);\n                        &::before{\n                            -webkit-transform: translateX(12px);\n                            -ms-transform: translateX(12px);\n                            transform: translateX(12px);\n                        }\n                    }\n                }\n                span{\n                    font-size: 12px;\n                    color: var(--AA-gloabl-text-color);\n                    cursor: pointer;\n                    font-weight: 500;\n                    &.yes{\n                       \n                    }\n                    &.no{\n                        \n                    }\n                    &.enabled{\n                        display: block;\n                    }\n                    &.disabled{\n                        display: none;\n                    }\n                }\n            }\n            &:disabled{\n                + .aa-slider{\n                    .slide-parent{\n                        .slider-btn{\n                            opacity: 0.5;\n                        }\n                    }\n                }\n            }\n        }\n        &:disabled{\n            cursor: auto;\n            + .aa-slider{\n                .slide-parent{\n                    .slider-btn{\n                        opacity: 0.5;\n                    }\n                }\n            }\n        }\n    }\n    .aa-slider{\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        flex-wrap: wrap;\n        background: transparent;\n        padding: 0;\n        border: 0;\n        outline: 0;\n        .slide-parent{\n            position: relative;\n            width: 28px;\n            height: 16px;\n            .slider-btn{\n                position: absolute;\n                cursor: pointer;\n                width: 100%;\n                height: 100%;\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n                transition: 0.4s;\n                border-radius: 10px;\n                background: var(--AA-global-white-bg);\n                border: 0;\n                padding: 0;\n                outline: 0;\n                &:focus{\n                    box-shadow: 0px 0px 0px 4px #EFF4FF;\n                }\n                &::before{\n                    position: absolute;\n                    content: \"\";\n                    height: 12px;\n                    width: 12px;\n                    top: 2px;\n                    left: 2px;\n                    right: 0;\n                    background-color: var(--AA-global-white-bg);\n                    transition: 0.4s;\n                    border-radius: 50%;\n                    filter: drop-shadow(0px 0.778px 1.556px rgba(16, 24, 40, 0.06)) drop-shadow(0px 0.778px 2.333px rgba(16, 24, 40, 0.10));\n                }\n            }\n        }\n        span{\n            font-size: 12px;\n            color: var(--AA-gloabl-text-color);\n            cursor: pointer;\n            font-weight: 500;\n            &.show-alwyas-text{\n\n            }\n            &.no{\n                color: var(--AA-gloabl-text-color);\n            }\n            &.yes{\n               \n            }\n            &.enabled{\n                color: var(--AA-gloabl-text-color);\n                display: none;\n            }\n            &.disabled{\n                display: block;\n            }\n        }\n    }\n}","\n.aa-dropdown{\n    position: relative;\n    .aa-dropdown-toggle {\n        white-space: nowrap;\n    }\n    &.show{\n        .aa-dropdown-toggle {\n            svg{\n                &.arrow-icon{\n                    transform: rotate(180deg);\n                }\n            }\n        }\n        .aa-dropdown-content{\n            display: block;\n        }\n    }\n    &.aa-elipse-dropdown{\n        .aa-dropdown-toggle{\n            display: flex;\n            width: 22px;\n            height: 22px;\n            justify-content: center;\n            align-items: center;\n            gap: 10px;\n            border-radius: 4px;\n            background: var(--AA-gloabl-bg-secondary);\n            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);\n            border: 0;\n            padding: 0;\n        }\n        .aa-dropdown-content{\n            right: 0;\n            padding: 0;\n        }\n    }\n}\n  \n// The dropdown menu\n.aa-dropdown-content {\n    position: absolute;\n    z-index: 1000;\n    display: none;\n    min-width: auto;\n    margin: 0;\n    color: var(--AA-gloabl-text-color);\n    text-align: left;\n    list-style: none;\n    background-clip: padding-box;\n    border-radius: 8px;\n    background: var(--AA-global-white-bg);\n    box-shadow: 0px 4px 8px 0px rgba(32, 33, 36, 0.15);\n    border: 0;\n    padding: 8px 12px;\n}\n\n.aa-dropdown-item {\n    display: block;\n    width: 100%;\n    padding: 8px 14px;\n    clear: both;\n    text-align: inherit;\n    text-decoration: none;\n    white-space: nowrap;\n    background-color: transparent;\n    border: 0;\n    color: var(--AA-gloabl-text-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    border-radius: 6px;\n    &:hover,\n    &:focus {\n        color: var(--AA-gloabl-text-color);\n        background: var(--AA-gloabl-bg-secondary);\n    }\n\n    &.active,\n    &:active {\n        color: var(--AA-gloabl-text-color);\n        text-decoration: none;\n        background: var(--AA-gloabl-bg-secondary);\n    }\n\n    &.disabled,\n    &:disabled {\n        opacity: 0.5;\n        pointer-events: none;\n        background-color: transparent;\n    }\n}\n  \n// PLaybook dropdowns\n  \n.playbook-dropdown-content{\n    min-width: 250px;\n    max-height: 300px;\n    overflow: auto;\n    max-width: 350px;\n    .heading-text-scripts{\n        border-radius: 8px 8px 0px 0px;\n        background: var(--AA-gloabl-bg-secondary);\n        padding: 8px 10px;\n        color: var(--AA-gloabl-text-color);\n        font-size: 11px;\n        font-weight: 600;\n        line-height: normal;\n        text-transform: capitalize;\n    }\n    .aa-dropdown-item{\n        display: flex;\n        align-items: center;\n        gap: 5px;\n        margin: 1px 0;\n        white-space: normal;\n        &.selected{\n            background: var(--AA-gloabl-bg-secondary);\n        }\n        p{\n            width: 100%;\n            color: var(--AA-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 500;\n            line-height: 18px;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n        .primaryBtn{\n            border-radius: 16px;\n            background: var(--AA-global-theme-bg);\n            color: var(--AA-global-white-color);\n            font-size: 12px;\n            font-weight: 500;\n            height: 22px;\n            padding: 0 8px;\n            flex-shrink: 0;\n        }\n        span{\n            flex-shrink: 0;\n            color: var(--AA-gloabl-text-desc-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: 18px;\n            opacity: 0.8;\n        }\n    }\n}","// _flex.scss\n\n@mixin margins($value) {\n    margin-top: $value;\n    margin-bottom: $value;\n    margin-left: $value;\n    margin-right: $value;\n}\n\n$gaps: (\n  4: 4px,\n  6: 6px,\n  8: 8px,\n  10: 10px,\n  12: 12px,\n  16: 16px,\n  20: 20px,\n  24: 24px,\n  sm: 8px,\n  md: 16px,\n  lg: 24px,\n  xl: 32px,\n  xxl: 48px\n);\n\n@each $size, $value in $gaps {\n  .a-gap-#{$size} {\n    gap: $value;\n  }\n}\n\n\n$radiuses: (\n  4: 4px,\n  6: 6px,\n  8: 8px,\n  12: 12px,\n  16: 16px,\n  999: 999px\n);\n\n@each $size, $value in $radiuses {\n  .a-radius-#{$size} {\n    border-radius: $value;\n  }\n}\n\n// Padding utilities\n$paddings: (\n  default: 24px,\n  xs: 4px,\n  sm: 8px,\n  smm: 10px,\n  md: 12px,\n  lg: 16px,\n  xl: 20px,\n  xxl: 24px\n);\n\n@each $size, $value in $paddings {\n  .a-padding-#{$size} {\n    padding: $value;\n  }\n  .a-padding-#{$size}-top {\n    padding-top: $value;\n  }\n  .a-padding-#{$size}-bottom {\n    padding-bottom: $value;\n  }\n  .a-padding-#{$size}-left {\n    padding-left: $value;\n  }\n  .a-padding-#{$size}-right {\n    padding-right: $value;\n  }\n}\n\n@mixin flex {\n    display: flex;\n}\n\n@mixin flex-inline {\n    display: inline-flex;\n}\n\n@mixin flex-direction($direction) {\n    flex-direction: $direction;\n}\n\n@mixin flex-wrap($wrap) {\n    flex-wrap: $wrap;\n}\n\n@mixin justify-content($value) {\n    justify-content: $value;\n}\n\n@mixin align-items($value) {\n    align-items: $value;\n}\n\n@mixin align-content($value) {\n    align-content: $value;\n}\n\n@mixin width($value) {\n    width: $value;\n}\n\n// Mixin for setting height\n@mixin height($value) {\n    height: $value;\n}\n\n@mixin gap($value) {\n    gap: $value;\n}\n\n.a-p-0{\n    padding: 0 !important;\n}\n\n.a-m-0{\n    margin: 0 !important;\n}\n\n.a-mb-8{\n    margin-bottom: var(--default, 8px);\n}\n// Utility classes with -a- prefix\n\n.a-gap-4{\n    gap: var(--default, 4px);\n}\n\n.a-gap-8{\n    gap: var(--default, 8px);\n}\n\n.a-gap-12{\n    gap: var(--default, 12px);\n}\n\n.a-gap-16{\n    gap: var(--default, 16px);\n}\n\n// Utility classes with -a- prefix\n.a-position-relative{\n    position: relative;\n}\n.a-position-absolute{\n    position: absolute;\n}\n.a-d-none{\n    display: none\n}\n.a-flex {\n    @include flex;\n}\n\n.a-flex-shrink-0{\n    flex-shrink: 0;\n}\n\n.a-flex-inline {\n    @include flex-inline();\n}\n\n.a-flex-row {\n    @include flex-direction(row);\n}\n\n.a-flex-row-reverse {\n    @include flex-direction(row-reverse);\n}\n\n.a-flex-column {\n    @include flex-direction(column);\n}\n\n.a-flex-column-reverse {\n    @include flex-direction(column-reverse);\n}\n\n.a-flex-wrap {\n    @include flex-wrap(wrap);\n}\n\n.a-flex-nowrap {\n    @include flex-wrap(nowrap);\n}\n\n.a-flex-wrap-reverse {\n    @include flex-wrap(wrap-reverse);\n}\n\n.a-justify-content-start {\n    @include justify-content(flex-start);\n}\n\n.a-justify-content-end {\n    @include justify-content(flex-end);\n}\n\n.a-justify-content-center {\n    @include justify-content(center);\n}\n\n.a-justify-content-between {\n    @include justify-content(space-between);\n}\n\n.a-justify-content-around {\n    @include justify-content(space-around);\n}\n\n.a-align-items-start {\n    @include align-items(flex-start);\n}\n\n.a-align-items-end {\n    @include align-items(flex-end);\n}\n\n.a-align-items-center {\n    @include align-items(center);\n}\n\n.a-align-items-baseline {\n    @include align-items(baseline);\n}\n\n.a-align-items-stretch {\n    @include align-items(stretch);\n}\n\n.a-align-content-start {\n    @include align-content(flex-start);\n}\n\n.a-align-content-end {\n    @include align-content(flex-end);\n}\n\n.a-align-content-center {\n    @include align-content(center);\n}\n\n.a-align-content-between {\n    @include align-content(space-between);\n}\n\n.a-align-content-around {\n    @include align-content(space-around);\n}\n\n\n.a-width-100 {\n    @include width(100%);\n}\n\n.a-height-100 {\n    @include height(100%);\n}\n\n.a-overflow-hidden{\n    overflow: hidden;\n}\n\n\n\n\n.a-form-checkbox-switch{\n    position: relative;\n    input{\n        width: 28px;\n        height: 16px;\n        appearance: none;\n        // border: 1px solid var(--AA-gloabl-border);\n        border: 1px solid var(--AA-static-border, #E4E7EC);\n        border-radius: 16px;\n        transition: background-position .15s ease-in-out;\n        +.a-form-checkbox-switch-round{\n            width: 10px;\n            height: 10px;\n            border-radius: 16px;\n            background-color: var(--AA-static-border, #E4E7EC);\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            transition: transform .15s ease-in-out;\n        }\n        &:checked{\n            background-color: var(--AA-global-theme-bg);\n            +.a-form-checkbox-switch-round{\n                background-color: var(--AA-global-white-bg);\n                transform: translateX(12px);\n            }\n        }\n    }\n}\n\n\n.badge-text{\n    height: 16px;\n    padding: 2px 8px;\n    border-radius: 16px;\n    background: var(--AA-gloabl-bg-secondary);\n    color: var(--AA-gloabl-text-color);\n    text-align: center;\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 18px;\n}\n\n.radio-check-form{\n    input{\n        width: 16px;\n        height: 16px;\n        outline: 1px solid var(--AA-static-border);\n        appearance: none;\n        border-radius: 100%;\n        flex-shrink: 0;\n        cursor: pointer;\n        &:checked{\n            background: var(--AA-global-theme-bg);\n            border: 4px solid var(--AA-global-white-bg);\n            outline-color: var(--AA-global-theme-bg);\n        }\n    }\n    label{\n        cursor: pointer;\n    }\n}\n\n.cursor-pointer{\n    cursor: pointer;\n}\n\n.a-text-uppercase{\n    text-transform: uppercase;\n}",".aa-tooltip {\n    position: fixed;\n    max-width: 300px;\n    border: 0px solid var(--AA-gloabl-border);\n    box-shadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n    background: var(--AA-global-white-bg);\n    border-radius: 8px;\n    padding: 9px 12px;\n    color: var(--AA-gloabl-text-color);\n    text-align: center;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    min-width: 150px;\n    z-index: 9999;\n    &.aa-custom-tooltip {\n        background: var(--AA-primary-color);\n        color: var(--AA-global-white-color);\n    }\n    &.tooltip-top {\n        margin-top: -5px;\n        transform: translate(-50%, -50%) !important;\n    }\n    &.tooltip-bottom {\n        margin-top: 5px;\n    }\n    &.tooltip-left {\n        margin-left: -5px;\n        transform: translate(-100%, -50%) !important;\n    }\n    \n    &.tooltip-right {\n        margin-left: 5px;\n        transform: translate(0, -50%) !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
